/**
 * @license
 * @qwik.dev/core 2.0.0-beta.45-dev+91faaa3
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as Ue, isBrowser as Be } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { getAsyncLocalStorage as He } from "@qwik.dev/core/async-local-storage";

export { getAsyncLocalStorage as _getAsyncLocalStorage } from "@qwik.dev/core/async-local-storage";

import { p as ze } from "@qwik.dev/core/preloader";

const Qe = !1;

const Ye = (t, ...n) => Ze(!1, t, ...n);

const Ge = (t, ...n) => Ze(!0, t, ...n);

const Ze = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

const Ke = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const tr = t => typeof t === "object" && t !== null;

const nr = t => Array.isArray(t);

const er = t => typeof t === "string";

const rr = t => typeof t === "function";

const ir = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = Ze(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const sr = "2.0.0-beta.45-dev+91faaa3";

const or = "<sync>";

const lr = t => typeof t === "function" && typeof t.getSymbol === "function";

const Xd = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const cr = "q:renderFn";

const ur = "q:componentHash";

const fr = "q:targetEl";

const ar = "⚡️";

const hr = "q:slot";

const dr = "q:sparent";

const pr = "q:s";

const $r = "[q\\:patch]";

const yr = "q:r";

const Dd = "q:rp";

const wr = "q:cc";

const mr = "q:style";

const vr = "style[q\\:style]";

const _r = vr + ",style[q\\:sstyle]";

const br = "q:sstyle";

const gr = "q:ctx";

const Er = "q:brefs";

const Sr = (t, n) => t["qFuncs_" + n] || [];

const kr = "q:base";

const Rr = "q:container-island";

const Pr = "/" + Rr;

const Tr = "q:ignore";

const Ar = "/" + Tr;

const qr = "q:container";

const Ir = "/" + qr;

const Mr = "q:template";

const Nr = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const xr = "http://www.w3.org/1999/xhtml";

const Cr = "http://www.w3.org/2000/svg";

const Or = "http://www.w3.org/1998/Math/MathML";

const jr = "qRender";

const Lr = "q-e:qvisible";

const Fr = "q:id";

const Xr = "q:key";

const Dr = "q:props";

const Wr = "q:seq";

const Vr = "q:seqIdx";

const zr = "q:p";

const Ur = "q:ps";

const Qr = ":on";

const Hr = ":onIdx";

const Jr = ":onFlags";

const Yr = ":cursorBoundary";

const Gr = ":nearestCursorBoundary";

const Zr = ":";

const Kr = "dangerouslySetInnerHTML";

const ni = () => ({
    isServer: Ue,
    importSymbol(t, n, e) {
        if (Ue) {
            const t = Xd(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw ir(6, [ e ]);
        }
        if (!n) {
            throw ir(14, [ e ]);
        }
        if (!t) {
            throw ir(13, [ n, e ]);
        }
        const s = ei(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const ei = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(kr) ?? s, s);
    return new URL(e, o);
};

let ri = /*#__PURE__ */ ni();

const ii = t => ri = t;

const si = () => ri;

const Wd = () => ri.isServer;

/*@__INLINE__*/ const oi = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const li = (t, n, e, s, o = !1) => {
    const r = oi(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const ci = (t, n, e) => {
    const s = oi(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const ui = (t, n, e) => oi(t, n, e) >= 0;

const fi = t => t.nodeType === 1;

const ai = 100;

const hi = t => {
    try {
        return !!t && typeof t == "object" && typeof t.then === "function";
    } catch {
        return !1;
    }
};

const di = (t, n, e) => {
    try {
        const s = t();
        return hi(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const pi = (t, n) => hi(t) ? t.then(n) : n(t);

const $i = t => new Promise(n => {
    setTimeout(n, t);
});

const yi = t => {
    throw t;
};

function t(t, n = yi) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!hi(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = ai;
    const r = async e => {
        for (;hi(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!hi(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const wi = t => {
    const n = t.$n;
    return n || t;
};

const Vd = t => t.It;

const mi = Symbol();

class vi {
    [mi]=void 0;
}

const _i = "q:type";

const bi = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Si = 124;

const ki = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

const Ri = t => t === "foreignObject";

const Pi = t => t === "svg" || Ri(t);

const Ti = t => t === "math";

function n(t, e, s, o = !1) {
    const r = t.ownerDocument.createElementNS(s, e);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== Zr && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let e = 0; e < t.childNodes.length; e++) {
            const i = t.childNodes[e];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(n(i, i.localName, s, o));
        }
    }
    return r;
}

const Ai = {
    elementNamespace: xr,
    elementNamespaceFlag: 0
};

function e(t, n) {
    const e = !t || !!Hl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && Ri(Hl(t));
    let o = xr;
    let r = 0;
    const i = typeof n === "string" || $l(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return Pi(t);
        }
        if ($l(t)) {
            return Pi(Hl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Cr;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Ti(t);
        }
        if ($l(t)) {
            return Ti(Hl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Or;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Cr : e ? Or : xr;
        r = t.flags & 1536;
    }
    Ai.elementNamespace = o;
    Ai.elementNamespaceFlag = r;
    return Ai;
}

const qi = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function r(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Ii(t.slice(s, -1));
        }
    }
    return null;
}

const Ii = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = Mi(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const Mi = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Ni = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

class xi {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [mi]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Ci extends xi {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class Oi extends Ci {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class ji extends xi {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Li = [];

const Fi = [];

function i(t, n) {
    const e = $(n).priority;
    let s = Li.length;
    for (let t = 0; t < Li.length; t++) {
        const n = $(Li[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Li.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function s() {
    for (let t = 0; t < Li.length; t++) {
        const n = Li[t];
        let e = !1;
        for (let t = 0; t < Fi.length; t++) {
            const s = Fi[t];
            if (yc(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function o(t, n) {
    Fi.push(t);
    u(t, n, !0);
    n.o++;
}

function l(t, n) {
    f(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    i(n, t);
}

function c(t, n, e) {
    const s = $(e);
    if (!s || s === n) {
        return;
    }
    u(e, t, !1);
    f(e, t);
    p(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function u(t, n, e) {
    e || (t.flags &= -257);
    const s = Li.indexOf(t);
    if (s !== -1) {
        Li.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function f(t, n) {
    const e = Fi.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = Fi.length - 1;
    e !== s && (Fi[e] = Fi[s]);
    Fi.pop();
    n.o--;
    return !0;
}

const Xi = new WeakMap;

const Di = ":nodeProps";

const Wi = ":nodeDiff";

const Vi = ":errorData";

const zi = ":signal";

const Ui = ":inlineComponentData";

const Bi = new WeakMap;

function a(t, n) {
    let e = Bi.get(t);
    e || Bi.set(t, e = []);
    e.includes(n) || e.push(n);
}

function h(t) {
    const n = Bi.get(t);
    n && Bi.delete(t);
    return n;
}

function d(t, n, e) {
    n.position = e;
    e && $n(e) && function s(t, n, e) {
        const s = $(e);
        if (!s || s === n) {
            return;
        }
        u(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = h(n);
            if (s) {
                for (let n = 0; n < s.length; n++) {
                    a(t, s[n]);
                }
            }
            const o = n.extraPromises;
            if (o && o.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...o) : t.extraPromises = o;
            }
            p(t, n);
        })(n, s);
    }(t, n, e);
}

function p(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.pendingBoundary && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function $(t) {
    return Xi.get(t) ?? null;
}

const Qi = Symbol();

const Hi = Symbol();

const Ji = Symbol();

const Yi = Symbol();

const Gi = Symbol();

const Zi = Symbol();

const Ki = [];

const ts = {};

Object.freeze(Ki);

Object.freeze(ts);

function y(t) {
    return new Proxy({}, new ns(t));
}

class ns {
    owner;
    ft=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Qi) {
            return this.owner.constProps;
        }
        if (n === Hi) {
            return this.owner.varProps;
        }
        if (n === Ji) {
            return this.owner;
        }
        if (n === Yi) {
            return this;
        }
        let e;
        if (n === "children") {
            e = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            e = is(this.owner, n);
            n in this.owner.varProps && es(this, n);
        }
        return e instanceof Ls ? e.value : e;
    }
    set(t, n, e) {
        if (n === Ji) {
            this.owner = e;
        } else if (n === "children") {
            this.owner.children = e;
        } else if (n === Qi) {
            this.owner.constProps = e;
        } else if (n === Hi) {
            this.owner.varProps = e;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === ts ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== e) {
                this.owner.varProps[n] = e;
                rs(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && rs(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Qi || n === Hi) {
            return !0;
        }
        const e = n in this.owner.varProps;
        if (typeof n === "string") {
            e && es(this, n);
            if (typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
        }
        return e || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const es = (t, n) => {
    const e = sa();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.hn;
    s && Cn(t.owner._proxy, n, t, s);
};

const rs = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ft, n);
    e && Cc(t.$, t, e);
    return !!e;
};

const is = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const ss = (t, n) => os(t)?.[n] || ls(t)?.[n] || null;

const os = t => {
    if (!t) {
        return null;
    }
    return Hi in t ? "children" in t ? {
        ...t[Hi],
        children: t.children
    } : t[Hi] : t;
};

const ls = t => {
    if (!t) {
        return null;
    }
    return Qi in t ? t[Qi] : null;
};

const cs = t => t && Hi in t;

const us = Symbol();

class fs {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const as = Symbol();

const hs = Symbol();

const ds = Symbol();

function w(t, n, e) {
    t[mi] || (Ue && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Er, new Map) : t[mi] = new Map);
    const o = t[mi];
    let r = o.get(n);
    if (!r) {
        r = new fs(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const ps = (t, n) => (e, s) => {
    const o = We();
    o.hn = w(t, ":");
    o.$ = n || void 0;
    return Fe(o, () => {
        if (rr(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (qc(e)) {
            return e.value;
        }
        if (tr(e) && Qc(e)) {
            Cn(Vc(e), ds, Wc(e), o.hn);
            return e;
        }
        throw ir(2);
    });
};

class $s {
    Dt;
    ft=void 0;
    $=null;
    yn=null;
    constructor(t, n) {
        this.$ = t || sa()?.$ || null;
        this.Dt = n;
    }
    trigger() {
        Cc(this.$, this, this.ft);
    }
    force() {
        Cc(this.$, this, this.ft);
    }
    get untrackedValue() {
        return this.Dt;
    }
    set untrackedValue(t) {
        this.Dt = t;
    }
    get value() {
        const t = this.untrackedValue;
        this.wn();
        return t;
    }
    wn() {
        const t = sa();
        if (!t) {
            return;
        }
        this.$ === null && (this.$ = t.$);
        const n = t.hn;
        if (n) {
            const e = Ue;
            const s = this.ft ||= new Set;
            const o = __EXPERIMENTAL__.pendingBoundary && e;
            Ic(s, n);
            Mc(n, this);
            if (e) {
                const e = xc(t.$, this.$);
                o && e?.mn?.(this, n, null);
                Nc(n, e);
            }
        }
    }
    set value(t) {
        if (t !== this.Dt) {
            this.Dt = t;
            Cc(this.$, this, this.ft);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Dt
        };
    }
}

class ys {
    vn;
    _n=null;
    bn=!1;
    gn=!0;
    constructor(t, n, e) {
        this.vn = t;
        if (n !== void 0) {
            this.info = n;
            this.En = e;
        }
    }
    get track() {
        if (!this.Sn) {
            const t = ps(this.vn, this.vn.$);
            this.Sn = (n, e) => {
                if (this.vn.kn) {
                    throw ir(39);
                }
                return t(n, e);
            };
        }
        return this.Sn;
    }
    get abortSignal() {
        const t = this.Rn ||= new AbortController;
        this.bn && t.abort();
        return t.signal;
    }
    cache() {}
    get previous() {
        const t = this.vn.Dt;
        if (t !== us) {
            return t;
        }
    }
    cleanup=t => {
        typeof t === "function" && (this.Pn ||= []).push(t);
    };
}

class ws extends $s {
    Wt;
    h;
    [mi]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || sa()?.$, us);
        this.Wt = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Dt = typeof o === "function" ? o() : o);
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.Ut = r;
            this.Bt = [];
        }
        s.timeout && (this.Qt = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
    }
    clear() {
        this.Dt = us;
        this.invalidate();
    }
    invalidate(n) {
        if (this.kn) {
            return;
        }
        if (arguments.length > 0) {
            this.Tn = n;
            this.En = this.En === void 0 ? 1 : this.En + 1;
        }
        if (this.h & 512) {
            this.An(!0);
            return;
        }
        this.h |= 1;
        const e = We();
        e.$ = this.$ || void 0;
        const s = t(Xe.bind(this, e, this.p));
        hi(s) && s.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        try {
            return super.value;
        } catch (t) {
            !hi(t) && sa()?.hn?.consumer instanceof ws && this.wn();
            throw t;
        }
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.Tn = void 0;
            if (this.Bt) {
                for (let t = 0; t < this.Bt.length; t++) {
                    this.Bt[t].gn = !1;
                }
            } else {
                this.qn && (this.qn.gn = !1);
            }
            super.value = t;
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.qn?._n) {
            if (this.Dt === us || Ue) {
                throw this.qn?._n;
            }
            return this.Dt;
        }
        if (this.Vt && this.Dt === us) {
            throw this.Vt;
        }
        if (Ue && this.h & 64 && this.Dt === us) {
            throw ir(35);
        }
        return this.Dt;
    }
    set untrackedValue(t) {
        this.Dt = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = sa();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.hn;
            if (t) {
                Ic(this.yt ||= new Set, t);
                Mc(t, this);
                Nc(t, this.$);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.zt) {
            this.zt = t;
            Cc(this.$, this, this.yt);
        }
    }
    get untrackedPending() {
        this.p();
        if (Ue && this.qn?._n) {
            throw this.qn?._n;
        }
        return !!this.zt;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        this.In();
        if (t || this.Dt === us) {
            return t;
        }
        return bs(this);
    }
    In() {
        const t = sa();
        if (t && (this.$ ||= t.$ || null)) {
            const n = t.hn;
            if (n) {
                Ic(this.wt ||= new Set, n);
                Mc(n, this);
                Nc(n, this.$);
            }
        }
    }
    set untrackedError(t) {
        if (t !== this.Vt) {
            this.Vt = t;
            Cc(this.$, this, this.wt);
        }
    }
    get untrackedError() {
        this.p();
        if (Ue && this.qn?._n) {
            throw this.qn?._n;
        }
        return this.Dt === us ? void 0 : this.Vt;
    }
    An(t) {
        if (this.kn) {
            return;
        }
        this.h |= 1;
        t && (this.ft?.size || this.yt?.size || this.wt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.qn && this.Mn(this.qn, t);
    }
    vt() {
        if (!(this.h & 32) || this.Nn()) {
            return;
        }
        if (!Be) {
            return;
        }
        setTimeout(() => {
            this.Nn() || this.abort();
        });
    }
    async promise() {
        await t(() => this.p());
        for (;this.qn?._n; ) {
            await (this.qn?._n);
        }
    }
    p() {
        if (this.kn || !(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.xn();
        }
        const n = this.Wt;
        Ac(n);
        const e = this.qn;
        if (e && !e.bn) {
            e.bn = !0;
            e.Rn?.abort();
            this.Cn(e);
        }
        const s = new ys(this, this.Tn, this.En);
        this.qn = s;
        const o = this.On();
        let r;
        try {
            r = this.jn(n.resolved, s);
        } catch (t) {
            if (hi(t)) {
                throw t;
            }
            s.En === this.En && (this.Tn = void 0);
            this.h &= -2;
            this.Ln(s, t);
            this.Fn(o);
            return;
        }
        if (hi(r)) {
            this.h |= 512;
            this.h &= -2;
            let n = r;
            const e = () => {
                const t = n ?? this.jn(this.Wt.resolved, s);
                n = void 0;
                return t;
            };
            s._n = this.Xn(s, () => t(e), o);
            return;
        }
        s.En === this.En && (this.Tn = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = r;
        this.Fn(o);
    }
    On() {
        return this.wt?.size ? vs(this) : void 0;
    }
    Fn(t) {
        if (!t) {
            return;
        }
        const n = vs(this);
        (n.size !== t.size || Array.from(t).some(t => !n.has(t))) && Cc(this.$, this, this.wt);
    }
    jn(t, n) {
        if (this.kn) {
            throw ir(39);
        }
        const e = t;
        if (this.h & 1024) {
            let t = sa();
            t?.hn && (t = {
                ...t,
                hn: void 0
            });
            return Xe(t, e, [ n ]);
        }
        const s = this.$ ||= sa()?.$ || null;
        const o = w(this, ".");
        s && Tn(s, o);
        const r = We();
        r.$ = s || void 0;
        r.hn = o;
        return Xe(r, e, [ n ]);
    }
    xn() {
        if (Ue && this.h & 64) {
            this.zt = !0;
            this.$?.serializationCtx.xe.add(this);
            return;
        }
        this.h &= -2;
        const t = this.qn;
        t && this.Mn(t);
        const n = this.Ut === 0 ? Infinity : this.Ut ?? 1;
        if (this.Bt ? this.Bt.length >= n : t?._n) {
            this.h |= 1;
            return;
        }
        const e = this.En;
        const s = new ys(this, this.Tn, e);
        this.qn = s;
        this.Bt && this.Bt.push(s);
        s._n = this.Dn(s);
    }
    async Dn(n) {
        let e = this.Wt.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.Wt.resolve();
            if (this.kn || n.Rn?.signal.aborted) {
                n._n = null;
                return;
            }
        }
        this.Qt && (this.Wn = setTimeout(() => {
            const t = Error(`timeout ${this.Qt}ms`);
            this.Ln(n, t);
            n.Rn?.abort(t);
        }, this.Qt));
        return this.Xn(n, () => t(() => this.jn(e, n)), this.On());
    }
    async Xn(t, n, e) {
        try {
            const e = n();
            let s;
            if (hi(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t._n = null;
            if (t.gn) {
                const n = this.Bt;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].gn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t._n = null;
            this.Ln(t, n);
        }
        if ((() => t === this.qn)() && !this.kn) {
            clearTimeout(this.Wn);
            t.En === this.En && (this.Tn = void 0);
            this.Fn(e);
            this.h & 1 ? this.p() : this.untrackedPending = !1;
        }
    }
    Ln(t, n) {
        if (t !== this.qn || !t.gn) {
            return;
        }
        t.gn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.Vn(n);
    }
    Vn(t) {
        const n = [];
        const e = new Set;
        Oc(this.ft, n, e);
        Oc(this.wt, n, e);
        Oc(this.yt, n, e);
        this.$?.zn(t, n);
    }
    $dispose() {
        if (this.kn) {
            return;
        }
        this.kn = !0;
        this.h &= -2;
        clearTimeout(this.Wn);
        this.$ && Pn(this.$, this);
        const t = new Set(this.Bt);
        this.qn && t.add(this.qn);
        for (const n of t) {
            n.gn = !1;
            this.Mn(n);
        }
    }
    async Un() {
        clearTimeout(this.Wn);
        const t = this.qn;
        t && this.Mn(t);
        this.Bt ? await Promise.all(this.Bt.map(t => t._n)) : await (t?._n);
    }
    Nn() {
        return !!(this.ft?.size || this.yt?.size || this.wt?.size);
    }
    Mn(t, n) {
        if (t.bn) {
            return;
        }
        t.bn = !0;
        t.Rn?.abort(n);
        t._n = pi(t._n, () => this.Bn(t));
    }
    Cn(t) {
        const n = t.Pn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    hi(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Bn(t) {
        const n = () => {
            t._n = null;
            const n = this.Bt;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.Cn(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const ms = (t, n) => {
    const e = t[mi];
    if (!e) {
        return !1;
    }
    for (const t of e.values()) {
        if (!t.backRef) {
            continue;
        }
        const e = Array.from(t.backRef);
        for (let s = 0; s < e.length; s++) {
            const o = e[s];
            if (o instanceof $s && o.ft?.has(t) && n(o)) {
                return !0;
            }
        }
    }
    return !1;
};

const vs = t => {
    const n = new Set;
    ms(t, t => {
        (t instanceof ws || t[mi]) && n.add(t);
        return !1;
    });
    return n;
};

const _s = (t, n, e) => ms(t, t => {
    if (n.has(t)) {
        return !1;
    }
    n.add(t);
    return t instanceof ws && e(t) || _s(t, n, e);
});

const bs = t => {
    let n;
    _s(t, new Set([ t ]), t => {
        t.In();
        n = t.Vt;
        return !!n;
    });
    return n;
};

const gs = t => (n, ...e) => t.call(null, Xa(n), ...e);

class Es extends ws {
    constructor(t, n) {
        super(t, n, 17);
    }
    Qn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Ac(this.Wt);
        const t = ua(this.Wt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Dt === us ? e : this.Dt;
        const r = aa(() => this.Qn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Qn = !0;
        this.h &= -2;
        const i = this.Qn && r !== "undefined" || r !== this.Dt;
        if (i) {
            this.Dt = r;
            Cc(this.$, this, this.ft);
        }
    }
}

class Ss extends ws {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const ks = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const Rs = (t, n) => new ws(n?.container || null, t, Lc(n?.serializationStrategy || "always"), n);

const Ps = (t, n) => new Ss(n?.container || null, t, Lc(n?.serializationStrategy || "always"), n);

const Ts = t => new Es(null, t);

const As = t => new $s(null, t);

const qs = /*#__PURE__*/ gs(Rs);

const Is = gs(Ts);

const Ms = t => t.value;

const Ns = (t, n) => t[n];

const xs = t => {
    if (t.length === 1) {
        if (qc(t[0])) {
            return t[0].yn ||= new Ls(null, Ms, t, null);
        }
        if (Qc(t[0])) {
            return new Ls(null, Ms, t, null);
        }
        return t[0].value;
    }
    return new Ls(null, Ns, t, null);
};

const Cs = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!tr(n)) {
        return n[e];
    }
    if (qc(n)) {
        if (n instanceof Ls) {
            return n;
        }
        return xs(t);
    }
    if (cs(n)) {
        const s = n[Qi];
        const o = n[Hi];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Os(n, t);
        }
    } else {
        const s = Vc(n);
        if (s) {
            const n = s[e];
            return Os(n, t);
        }
    }
    return n[e];
};

const Os = (t, n) => qc(t) ? t : xs(n);

const js = (t, n) => {
    const e = Cs(t, n);
    if (e === Gi) {
        return t[n];
    }
    return e;
};

class Ls extends $s {
    ct;
    lt;
    Rt;
    h;
    _=void 0;
    [mi]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, us);
        this.ct = e;
        this.lt = n;
        this.Rt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this._) {
                this.$.setHostProp(this._, zi, this);
                mn(this.$, this._, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Cc(this.$, this, this.ft);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Dt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = aa(() => this.lt(...this.ct), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Dt;
        if (n) {
            this.h |= 2;
            this.Dt = t;
        }
    }
    st() {
        return this.lt === Ms && qc(this.ct[0]) ? this.ct[0] : this;
    }
    set value(t) {
        throw ir(31);
    }
    get value() {
        return super.value;
    }
}

class Fs {
    data;
    constructor(t) {
        this.data = t;
    }
}

const Xs = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

Object.prototype.hasOwnProperty;

class Ds {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || Xs(n) ? ts : n;
        this.constProps = !e || Xs(e) ? null : e;
    }
    get props() {
        return this._proxy ||= y(this);
    }
}

const Ws = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Vs = t => t instanceof Ds;

const zs = (t, n, e) => {
    if (typeof t === "string") {
        const s = Ne(n);
        return na(s, () => {
            Pa(Ta(s, t));
            return e();
        });
    }
    return e();
};

function m(t, n) {
    return zs(this, n, () => {
        const t = Ra[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function v(t, n) {
    return zs(this, n, () => {
        const t = Ra[0];
        t.value = n.checked;
    });
}

function _(t, n) {
    return zs(this, n, () => {
        if (Ra) {
            for (let t = 0; t < Ra.length; t++) {
                const n = Ra[t];
                n instanceof Ss && n.h & 64 && n.p();
            }
        }
    });
}

const Us = "bind:value";

const Bs = "bind:checked";

const Qs = "passive:";

const Hs = "preventdefault:";

const Js = Object.prototype.hasOwnProperty;

const Ys = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Ii(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Gs = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Ii(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Ii(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Ii(t.slice(11, -1));
    }
    return null;
};

const Zs = (t, n, e, s, o = !1) => {
    let i = t;
    let c = o;
    for (let t = 0; t < n.length; t++) {
        const o = n[t];
        const l = Gs(o);
        const u = r(o, s.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = e.get(u);
            (t === void 0 || t < e.get(o)) && (i[u] = i[o]);
            delete i[o];
        }
    }
    return i;
};

const Ks = (t, n, e, s, o, r, i) => new Ds(t, n, e, s, o, r, !1, i);

const to = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(Qs)) {
                    r.push(o);
                    t.add(Ii(o.slice(8)));
                } else {
                    o.startsWith(Hs) ? h.push(o) : Gs(o) !== null ? s.push(o) : o === Bs ? a = e[o] : o === Us && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(Qs)) {
                    i.push(s);
                    t.add(Ii(s.slice(8)));
                } else {
                    s.startsWith(Hs) ? d.push(s) : Gs(s) !== null ? o.push(s) : s === Bs ? a = n[s] : s === Us && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = Ys(e, r, h, t, l);
            l = l || e !== n;
            e = Zs(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = Ys(n, i, d, t, u);
            u = u || n !== e;
            n = Zs(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Js.call(n, Bs) && delete n[Bs];
                if (e && Js.call(e, Bs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Bs];
                }
                n.checked = a;
                const t = Ma(null, "_chk", v, null, [ a ]);
                if (e && Js.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Ws(n, "q-e:input", t) || c;
                }
                c = Ws(n, "q-e:input", t) || c;
            } else if (f) {
                n && Js.call(n, Us) && delete n[Us];
                if (e && Js.call(e, Us)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Us];
                }
                n.value = f;
                const t = Ma(null, "_val", m, null, [ f ]);
                if (e && Js.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Ws(n, "q-e:input", t) || c;
                }
                c = Ws(n, "q-e:input", t) || c;
            }
        }
        if (n && Js.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && Js.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Ds(t, n, e, s, o, r, c || !0, i);
};

const no = (t, n, e, s) => so(t, n, s);

const eo = (t, n, e, s, o) => so(t, {
    ...e,
    ...n
}, o);

const ro = (t, n, e, s, o, r) => so(t, {
    ...e,
    ...n,
    children: s
}, r);

const io = t => t.children;

const so = (t, n, e, s, o) => to(t, n, null, null, 0, e, o);

const oo = so;

const lo = so;

function b(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return to(t, n, null, s.children, 0, o);
}

const co = t => t.children;

const uo = (t, n) => new Ds(io, null, null, t.children, 0, n);

const fo = t => Ks(io, null, {
    [pr]: ""
}, t.children, 0, t.name ?? "");

const ao = Symbol();

const ho = () => null;

const po = () => null;

const $o = t => t.children;

const yo = (t, n) => so(uo, {
    children: so(wo, t)
}, n);

const wo = () => null;

let mo = null;

let vo = null;

function g(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    vo || (vo = t.setAttributeNS);
                    vo.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            mo || (mo = t.setAttribute);
            mo.call(t, n, e);
        })(t, n, e);
    }
}

function E(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const _o = Object.prototype.hasOwnProperty;

const bo = Object.prototype.propertyIsEnumerable;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

function k(t) {
    if (t) {
        for (const n in t) {
            if (S(n)) {
                return !0;
            }
        }
    }
    return !1;
}

const go = (t, n = [], e = {}) => {
    if (!tr(t) || !cs(t)) {
        if (t == null) {
            throw new TypeError(`Cannot destructure '${t}' as it is ${t}.`);
        }
        const s = Object(t);
        const o = Reflect.ownKeys(s);
        for (let t = 0; t < o.length; t++) {
            const r = o[t];
            !bo.call(s, r) || typeof r !== "symbol" && n.includes(r) || Object.defineProperty(e, r, {
                value: s[r],
                enumerable: !0,
                configurable: !0,
                writable: !0
            });
        }
        return e;
    }
    let s = null;
    const o = t[Qi];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[Hi];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return y(new Ds(null, r, s, null, 0, null));
};

function R(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && _o.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Ls) {
            return ha(n, t, ":", e);
        }
    }
    return is(n, "name") || "";
}

const Eo = t => ar + t;

const So = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + Eo(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const ko = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const Ro = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Po = t => {
    if (!t) {
        return "";
    }
    if (er(t)) {
        return t.trim();
    }
    const n = [];
    if (nr(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Po(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const To = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const Ao = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (nr(t)) {
            throw ir(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(To(e) + ":" + Io(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

const qo = t => t != null ? t + "" : null;

function P(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Po(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = Ao(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = qo(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const Io = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => ko.has(t))(t)) {
        return n + "px";
    }
    return n;
};

class Mo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class No {
    target;
    constructor(t) {
        this.target = t;
    }
}

class xo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class Co {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Oo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const jo = t => new Mo(t);

const Lo = t => new No(t);

const Fo = (t, n) => new xo(t, n);

const Xo = (t, n, e) => new Co(t, n, e);

const Do = (t, n, e, s = null, o = !1) => new Oo(t, n, e, s, o);

const Wo = () => {
    const t = la();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Wr);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Wr, s);
    }
    let o = t.$.getHostProp(e, Vr);
    o === null && (o = 0);
    t.$.setHostProp(e, Vr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Vo = t => {
    const n = rr(t) && !Ba(t) ? Fe(void 0, t) : t;
    return As(n);
};

const zo = t => Uo(Vo, t);

const Uo = (t, ...n) => {
    const {val: e, set: s} = Wo();
    if (e != null) {
        return e;
    }
    t = rr(t) && !Ba(t) ? ua(t, ...n) : t;
    return s(t);
};

function T(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    let e = null;
    let s = n;
    for (;s && !e; ) {
        e = I(s);
        s = s.slotParent || s.parent;
    }
    if (!e) {
        return;
    }
    const o = t.boundaries ||= [];
    if (!o.includes(e)) {
        o.push(e);
        e.value++;
    }
}

function A(t) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return null;
    }
    return bl(t, Yr, null) || null;
}

function q(t) {
    M(t, null);
}

function I(t) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return null;
    }
    return bl(t, Gr, null) || A(t);
}

function M(t, n) {
    __EXPERIMENTAL__.pendingBoundary && gl(t, Gr, n);
}

function N(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    M(t, n);
    const e = t.dirtyChildren;
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const s = e[t];
        N(s, A(s) || n);
    }
}

const Bo = t => {
    if (t.Un) {
        try {
            t.Un();
        } catch (t) {
            Ye(t);
        }
        t.Un = null;
    }
};

function x(n, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const t = Ne(s);
        return na(t, () => x(n, e, s, ca(e, s, t)));
    }
    const r = o.$;
    const i = o._;
    Rl(r, i);
    let c = n;
    if (i.flags & 64) {
        let t;
        if (!(i.flags & 128)) {
            t = !0;
            i.flags |= 128;
        }
        const o = t ? r.k : null;
        const l = bl(i, zr, o);
        if (l !== null) {
            c = () => n(e, s, l);
        } else {
            const t = bl(i, Ur, o);
            t !== null && (c = () => n(e, s, ...t));
        }
    }
    return t(() => {
        if (!(i.flags & 32)) {
            return Xe(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i, "event"));
}

function C(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Ne(n);
    return na(e, () => {
        const s = ca(t, n, e);
        typeof this === "string" && Pa(Ta(s.$, this));
        const o = Ra[0];
        return x(o, t, n, s);
    });
}

function O(t) {
    return t.R === t.T ? t.q : null;
}

function j(t) {
    return t.M || O(t);
}

function L(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = O(t);
    return e === o ? null : e;
}

const Qo = Object.prototype.hasOwnProperty;

function F(t, n, e, s, o, r) {
    gl(n, e, r);
    vn(t, Do(n.node, e, s, o, (n.flags & 512) !== 0));
}

function X(t, n, e, s) {
    return {
        $: t,
        N: n,
        O: e,
        j: s,
        L: [],
        X: [],
        D: [],
        R: null,
        M: null,
        W: null,
        q: null,
        T: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: null,
        G: 0,
        Z: 0,
        K: !0,
        tt: !1,
        nt: {
            et: new Fs({
                j: s,
                rt: !0
            }),
            it: new Fs({
                j: s,
                rt: !1
            })
        }
    };
}

function D(t, n, e, s, o) {
    const r = t ?? X(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.N = e;
        t.O = s;
        t.j = o;
        t.nt.et.data.j = o;
        t.nt.it.data.j = o;
        t.X.length = 0;
        t.D.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Ho = (t, n, e, s, o, r, i) => W(D(i, t, n, o, r), e, s);

const Jo = (t, n, e, s, o, r, i, c, l = !1, u) => W(D(u, t, n, i, c), e, s, o, r, l);

function W(t, n, e, s = Gl(e), o = null, r = !1) {
    V(t, n, e, s, o, r);
    const i = K(t);
    if (hi(i)) {
        return i.finally(() => {
            tt(t);
        });
    }
    tt(t);
}

function V(t, n, e, s = Gl(e), o = null, r = !1) {
    const i = t.tt;
    t.tt = r || i;
    t.R = e;
    t.W = null;
    t.M = s;
    t.q = o;
    t.T = e;
    H(t, n, !0);
    try {
        if (t.R.flags & 32) {
            return;
        }
        for (;t.L.length; ) {
            for (;t.G < t.Z; ) {
                if (typeof t.Y === "string") {
                    vt(t, t.Y);
                } else if (typeof t.Y === "number") {
                    vt(t, t.Y + "");
                } else if (t.Y && typeof t.Y === "object") {
                    if (Vs(t.Y)) {
                        const n = t.Y.type;
                        if (typeof n === "string") {
                            rt(t);
                            at(t, t.Y, n);
                            const e = t.Y.constProps && Qo.call(t.Y.constProps, Kr) || Qo.call(t.Y.varProps, Kr);
                            e ? t.W || nt(t, !1) : B(t, t.Y.children, !0);
                        } else if (typeof n === "function") {
                            if (n === co) {
                                rt(t);
                                $t(t, "F", t.Y.key);
                                B(t, t.Y.children, !0);
                            } else if (n === fo) {
                                rt(t);
                                G(t) || B(t, t.Y.children, !0);
                            } else if (n === gt) {
                                Y(t);
                                B(t, t.Y.children, !0, !0);
                            } else if (n === po) {
                                et(t);
                            } else if (n === ho) {
                                et(t);
                            } else {
                                rt(t);
                                yt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.Y)) {
                        B(t, t.Y, !1);
                    } else if (qc(t.Y)) {
                        $t(t, "S", null);
                        const n = t.Y instanceof Ls ? t.Y.st() : t.Y;
                        const e = t.M?.[mi]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Ls && (s = xt(e, n));
                        if (!s) {
                            const e = t.W || t.M;
                            B(t, z(t, () => ha(n, e, ".", t.$)), !0);
                        }
                    } else if (hi(t.Y)) {
                        $t(t, "A", null);
                        t.X.push(t.Y, t.W || t.M);
                    }
                } else {
                    t.Y === ao || vt(t, "");
                }
                U(t);
            }
            et(t);
            Z(t);
            Q(t);
        }
    } finally {
        t.tt = i;
    }
}

function z(n, e) {
    try {
        return e();
    } catch (s) {
        if (hi(s)) {
            const o = s.then(() => t(e));
            n.X.push(o, n.W || n.M);
            return null;
        }
        throw s;
    }
}

function U(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.G++;
    if (t.G < t.Z) {
        t.Y = t.J[t.G];
    } else if (t.L.length > 0 && t.L[t.L.length - 1] === !1) {
        return Q(t);
    }
    t.W !== null ? t.W = null : t.M = L(t, t.M);
}

function B(t, n, e, s = !1) {
    if (!s && (n == null || e && nr(n) && n.length === 0)) {
        nt(t);
        return;
    }
    H(t, n, e);
    if (e) {
        const n = !s && t.tt || !!t.W || !Gl(t.M);
        t.tt = n;
        t.H = null;
        t.U = null;
        t.B = null;
        t.R = t.W || t.M;
        t.M = Gl(t.R);
        t.W = null;
    }
    t.K = !1;
}

function Q(t) {
    const n = t.L.pop();
    if (n) {
        t.tt = t.L.pop();
        t.H = t.L.pop();
        t.U = t.L.pop();
        t.B = t.L.pop();
        t.W = t.L.pop();
        t.M = t.L.pop();
        t.R = t.L.pop();
    }
    t.Y = t.L.pop();
    t.Z = t.L.pop();
    t.G = t.L.pop();
    t.J = t.L.pop();
    U(t);
}

function H(t, n, e) {
    t.L.push(t.J, t.G, t.Z, t.Y);
    e && t.L.push(t.R, t.M, t.W, t.B, t.U, t.H, t.tt);
    t.L.push(e);
    if (Array.isArray(n)) {
        t.G = 0;
        t.Z = n.length;
        t.J = n;
        t.Y = t.Z > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.G = 0;
        t.Y = null;
        t.J = null;
        t.Z = 0;
    } else {
        t.G = 0;
        t.Y = n;
        t.J = null;
        t.Z = 1;
    }
}

function J(t) {
    if (t.W) {
        return j(t);
    }
    return L(t, t.M) || O(t);
}

function Y(t) {
    const n = t.Y;
    const e = n.key;
    t.M = bl(t.R, e, n => ql(t.$.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.W = dl();
        gl(t.W, hr, e);
        t.W.slotParent = t.R;
        gl(t.R, e, t.W);
    }
}

function G(t) {
    const n = t.Y;
    const e = Sc(t.R);
    const s = R(e, n, t.$);
    const o = is(n, Yr) || null;
    const r = e ? bl(e, s, null) : null;
    if (r == null) {
        t.W = dl();
        gl(t.W, hr, s);
        gl(t.W, Yr, o);
        N(t.W, o);
        e && gl(e, s, t.W);
        Vl(t.N, t.R, t.W, J(t));
        return !1;
    }
    if (r === t.M) {} else {
        const n = r.parent;
        t.W = r;
        gl(t.W, hr, s);
        gl(t.W, Yr, o);
        N(t.W, o);
        e && gl(e, s, t.W);
        Wl(t.N, t.W);
        Vl(t.N, t.R, t.W, J(t));
        n && $l(n) && !n.firstChild && Hl(n) === Mr && Bl(t.N, n.parent, n, !0);
    }
    return !0;
}

function Z(t) {
    const n = t.H;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            kt(t.$, t.N, e, t.O);
            Bl(t.N, t.R, e, !0);
        }
        n.clear();
        t.H = null;
    }
    t.M = null;
}

function K(t) {
    for (;t.X.length; ) {
        const n = t.X.shift();
        const e = t.X.shift();
        if (hi(n)) {
            return n.then(n => {
                V(t, n, e);
                return K(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return K(t);
            });
        }
        V(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => K(t));
    }
}

function tt(t) {
    t.N = null;
    t.O = null;
}

function nt(t, n = !0) {
    const e = t.M && Gl(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            kt(t.$, t.N, s, t.O);
            s = s.nextSibling;
        }
        Ql(t.N, t.M, e, n);
    }
}

function et(t) {
    const n = O(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = L(t, t.M);
            if (t.R === n.parent) {
                kt(t.$, t.N, n, t.O);
                Bl(t.N, t.R, n, !0);
            }
        }
    }
}

function rt(t) {
    if (t.M !== null && ml(t.M)) {
        const n = t.M;
        t.M = L(t, t.M);
        Bl(t.N, t.R, n, !0);
    }
}

function it(t, n, e) {
    if (qc(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw ir(15, [ e ]);
}

function st(n, e, s, o, r) {
    return t(() => ha(o, e, s, n, r));
}

function ot(t, n, e, s, o) {
    const r = t.j;
    const i = s.then(t => g(n, e, P(e, t, r), o));
    t.D.push(i);
}

function lt(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(qr, "html");
    }
}

function ct(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ut(t, n, s, o) {
    const r = function i(t, n) {
        const s = Ul(t.R, !0);
        const o = e(s, n);
        const r = document;
        const i = o.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(o.elementNamespace, n);
        t.W = fl(i, n);
        t.W.flags |= o.elementNamespaceFlag;
        return i;
    }(t, s);
    const c = t.W;
    const l = (c.flags & 512) !== 0;
    const {constProps: u} = n;
    if (u) {
        for (const n in u) {
            let e = u[n];
            if (qi(n)) {
                ft(n, e, r, c, t);
                continue;
            }
            if (n === "ref" && it(e, r, o)) {
                continue;
            }
            qc(e) && (e = st(t.$, t.W, n, e, t.nt.et));
            if (hi(e)) {
                ot(t, r, n, e, l);
                continue;
            }
            if (n === Kr) {
                lt(r, e);
                continue;
            }
            if (s === "textarea" && n === "value" && ct(r, e)) {
                continue;
            }
            g(r, n, P(n, e, t.j), l);
        }
    }
    const f = n.key;
    f && (t.W.key = f);
    if (t.j) {
        const e = Qo.call(n.varProps, "class") || n.constProps && Qo.call(n.constProps, "class");
        e || r.setAttribute("class", t.j);
    }
    jl(t.N, t.R, t.W, j(t));
}

function ft(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = x.bind(null, n));
    }
    const i = r === "e:qvisible";
    (t.charAt(2) !== "e" || i) && El(o.N, s, t, "");
    i || r === "d:qinit" || r === "d:qidle" ? a($(o.O), r) : Sl(o.$, r);
}

function at(t, n, e) {
    if (t.tt) {
        ut(t, n, e, null);
    } else {
        const s = t.M && $l(t.M);
        const o = s && e === Hl(t.M);
        const r = n.key;
        const i = s && t.M.key;
        if (o && r === i) {
            dt(t, e, r);
        } else {
            const s = ht(e, r);
            pt(t, e, r, s, t.R) && ut(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.W || t.M;
    s && function r(t, n, e, s) {
        t.tt || Rl(t.$, n);
        const o = n.props;
        const r = (n.flags & 1536) === 0;
        for (const i in e) {
            const c = e[i];
            const l = o && r && !Qo.call(o, i) ? i.toLowerCase() : i;
            if (o && Qo.call(o, l)) {
                const e = o[l];
                if (l !== i) {
                    gl(n, l, null);
                    gl(n, i, e);
                }
                At(c, e) || Yo(t, n, i, c, s);
            } else {
                c != null && Yo(t, n, i, c, s);
            }
        }
        if (o) {
            for (const r in o) {
                Qo.call(e, r) || r.charAt(0) === ":" || qi(r) || Yo(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Yo = (t, n, e, s, o) => {
    if (qi(e)) {
        ft(e, s, n.node, n, t);
        return;
    }
    if (e === zr || e === Ur) {
        gl(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (it(s, t, o)) {
            return;
        }
    }
    const i = n[mi]?.get(e);
    if (qc(s)) {
        const o = s instanceof Ls ? s.st() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Tn(t.$, i);
        const r = n;
        s = st(t.$, r, e, o, t.nt.it);
    } else {
        i && Tn(t.$, i);
    }
    if (hi(s)) {
        const o = n;
        const i = s.then(n => {
            F(t.N, o, e, n, t.j, r);
        });
        t.D.push(i);
        return;
    }
    F(t.N, n, e, s, t.j, r);
};

function ht(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function dt(t, n, e) {
    const s = ht(n, e);
    if (s && t.H?.has(s)) {
        t.H.delete(s);
        return !0;
    }
    return !1;
}

function pt(t, n, e, s, o, r) {
    t.W = function i(t, n, e) {
        let s = null;
        if (t.U === null) {
            const o = t.M;
            if (o) {
                const s = $l(o) ? Hl(o) : null;
                const r = _t(o) || bt(o, t.$.k);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.U = new Map;
            t.B = [];
            const r = O(t);
            let i = t.M;
            for (;i && i !== r; ) {
                const o = $l(i) ? Hl(i) : null;
                const r = _t(i) || bt(i, t.$.k);
                s === null && r == e && o == n ? s = i : r === null ? t.B.push(o, i) : t.U.set(ht(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.B.length; e += 2) {
                if (t.B[e] === n) {
                    s = t.B[e + 1];
                    t.B.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ht(n, e);
            const r = t.U.get(o);
            if (r) {
                s = r;
                t.U.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = $l(t.M) ? Hl(t.M) : null;
                    const e = _t(t.M) || bt(t.M, t.$.k);
                    if (e != null) {
                        const s = ht(n, e);
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                        t.U?.delete(s);
                    }
                }
                return;
            }
            const e = O(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = $l(s) ? Hl(s) : null;
                const e = _t(s) || bt(s, t.$.k);
                if (e != null) {
                    const o = ht(n, e);
                    t.H ||= new Map;
                    t.H.set(o, s);
                    t.U?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.W) {
        s || Vl(t.N, o, t.W, j(t));
        t.M = t.W;
        t.W = null;
        return !1;
    }
    if (s != null) {
        const n = t.H?.get(s) || null;
        if (n) {
            t.H.delete(s);
            if (r && t.M) {
                const n = _t(t.M) || bt(t.M, t.$.k);
                if (n != null) {
                    const e = $l(t.M) ? Hl(t.M) : null;
                    const s = ht(e, n);
                    if (s != null) {
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                    }
                }
            }
            n !== t.M && Vl(t.N, o, n, j(t));
            t.M = n;
            t.W = null;
            return !1;
        }
    }
    return !0;
}

function $t(t, n, e) {
    const s = n === "F";
    const o = _t(t.M);
    const r = t.M && vl(t.M);
    const i = r && o === e && (!s || !!e);
    if (i) {
        dt(t, null, o);
        return;
    }
    if (e === null || t.tt) {
        Ll(t.N, t.R, t.W = dl(), J(t));
        t.W.key = e;
        return;
    }
    if (pt(t, null, e, ht(null, e), t.R, !0)) {
        Ll(t.N, t.R, t.W = dl(), J(t));
        t.W.key = e;
    }
}

function yt(t, n) {
    const e = n[Ua];
    let s = t.W || t.M;
    const o = t.Y;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.ot;
        const l = bt(s, t.$.k);
        const u = o.key || c;
        const f = _t(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                dt(t, null, u);
            } else {
                wt(t, s, i, n);
                s = t.W;
                r = !0;
            }
        } else {
            if (pt(t, null, u, u, t.R)) {
                wt(t, s, i, n);
                r = !0;
            }
            s = t.W || t.M;
        }
        if (s) {
            const e = bl(s, Dr, t.$.k);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = Et(n[Qi], e[Qi], e[Yi], s, !1);
                        o ||= t;
                        const r = Et(n[Hi], e[Hi], e[Yi], s, !0);
                        o ||= r;
                        e[Ji] = n[Ji];
                    } else if (n) {
                        gl(t, Dr, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    wt(t, s, i, n);
                    s = t.W;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                gl(s, cr, i);
                s.flags &= -33;
                mn(t.$, s, 4, t.O);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Ds(gt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            li(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Vs(n) && is(n, hr) || "") + "";
                const i = oi(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            B(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = _t(s);
        const i = e === r;
        const c = bt(s, t.$.k);
        const l = c == null;
        if (s && !l || !s) {
            mt(t);
            s = t.W;
        } else if (i) {
            dt(t, null, e);
        } else {
            pt(t, null, e, e, t.R) && mt(t);
            s = t.W || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!vl(e) || bl(e, cr, null) === null); ) {
                e = e.parent || Sc(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[Ui] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            mn(t.$, s, 8, t.O);
        }
    }
}

function wt(t, n, e, s) {
    n && Pn(t.$, n);
    Ll(t.N, t.R, t.W = dl(), J(t));
    const o = t.Y;
    gl(t.W, cr, e);
    gl(t.W, Dr, s);
    t.W.key = o.key;
}

function mt(t) {
    Ll(t.N, t.R, t.W = dl(), J(t));
    const n = t.Y;
    gl(t.W, Dr, n.props);
    n.key && (t.W.key = n.key);
}

function vt(t, n) {
    if (t.M !== null) {
        const e = gc(t.M);
        if (e === 3) {
            if (n !== Jl(t.M)) {
                Yl(t.N, t.M, n);
                return;
            }
            return;
        }
    }
    jl(t.N, t.R, t.W = hl(document.createTextNode(n), n), j(t));
}

function _t(t) {
    if (t == null || ml(t)) {
        return null;
    }
    return t.key;
}

function bt(t, n) {
    if (t == null || ml(t)) {
        return null;
    }
    const e = bl(t, cr, n);
    return e ? e.ot : bl(t, ur, null);
}

function gt() {}

function Et(t, n, e, s, o = !0) {
    if (St(t) && St(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Er) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (n && i !== c && At(i, c)) {
                t[s] = c;
                continue;
            }
            if (!n || !At(i, c) && !qt(i, c)) {
                if (s === "class") {
                    if (Mt(i, c)) {
                        continue;
                    }
                } else if (s === "style" && It(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = rs(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Er) {
                continue;
            }
            if ((!t || !Qo.call(t, s)) && o) {
                delete n[s];
                const t = rs(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function St(t) {
    if (!t) {
        return !0;
    }
    return Xs(t);
}

function kt(t, n, e, s = null) {
    let o = e;
    const r = s && $n(s) ? $(s) : null;
    if (ml(e)) {
        Tt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && $n(o) && c(t, r, o);
        const l = o.flags;
        if (l & 3) {
            Pn(t, o);
            Tt(o);
            const r = l & 2 && bl(o, cr, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Wr);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (tr(r)) {
                            const n = Tc(r);
                            if (n) {
                                Pn(t, r);
                                if (r.h & 1) {
                                    r.h |= 16;
                                    mn(t, o, 128, s);
                                    continue;
                                }
                                Bo(r);
                            } else if (r instanceof ws || r instanceof Ls) {
                                if (r.h & 4) {
                                    continue;
                                }
                                r instanceof ws ? r.$dispose() : Pn(t, r);
                            }
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? ql(t.rootVNode, e) : e;
                                let c = Gl(o);
                                for (;c; ) {
                                    kt(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                Pt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = _l(o);
            if (i) {
                if (o === e) {
                    const n = Gl(o);
                    if (n) {
                        gn(n);
                        return;
                    }
                    Rt(t, o);
                }
            } else {
                const t = Gl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            l & 4 && Tt(o);
        }
        if (o === e) {
            return;
        }
        const u = o.nextSibling;
        if (u) {
            o = u;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function Rt(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, hr);
    e != null && t.getHostProp(n.slotParent, e) === n && gl(n.slotParent, e, null);
}

function Pt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Hl(s) === Mr) {
            Rt(t, e);
            Bl(n, s, e, !0);
        }
    }
}

function Tt(t) {
    t.flags |= 32;
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Ls && n instanceof Ls && Nt(n, t);
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    if (qc(t) && qc(n)) {
        const e = t instanceof Ls ? t.st() : t;
        const s = n instanceof Ls ? n.st() : n;
        return ua(() => e.value === s.value);
    }
    return !1;
}

function It(t, n) {
    if (t === n) {
        return !0;
    }
    return Ao(t) === Ao(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return Po(t) === Po(n);
}

function Nt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.lt === t.lt && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ct, t.ct);
}

function xt(t, n) {
    if (!(n instanceof Ls)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Ls && Nt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Go = (t, n, e, s, o) => {
    const r = De(t.fn, n, t);
    if (e) {
        r.hn = w(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, cr));
    if (lr(s)) {
        o = o || t.getHostProp(n, Dr) || ts;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (Ba(s)) {
        const t = s;
        i = () => Xe(r, t, [ o || ts, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => Xe(r, t, [ o || ts ]);
    }
    const l = Ue;
    const u = (e = 0) => di(() => {
        if (!c) {
            t.setHostProp(n, Vr, null);
            t.setHostProp(n, Hr, null);
        }
        e > 0 && pl(n) && Pn(t, n);
        return pi(i(o), t => pi(r.dn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < ai) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Qr);
        if (o) {
            return function r(t, n, e) {
                const s = Lt(n);
                let o = n;
                return pi(s, n => {
                    const s = !n;
                    let r = null;
                    for (const i in e) {
                        if (Object.prototype.hasOwnProperty.call(e, i)) {
                            let c = n;
                            let l = i;
                            if (s) {
                                if (i !== Lr && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    r = Xt();
                                    const n = Ue;
                                    n && t.ut(r) || (o = Ft(o, r));
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === Lr && (l = "q-d:qinit");
                                Ot(c, l, e[i]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (hi(t) && e < ai) {
            return t.then(() => u(++e));
        }
        if (e >= ai) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Ot(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Ni(n);
    c && jt(t, f, "capture");
    l && jt(t, f, "preventdefault");
    u && jt(t, f, "stoppropagation");
}

function jt(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === ts && (t.varProps = {});
    t.varProps[s] = !0;
}

function Lt(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Vs(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (nr(t)) {
            n.push(...t);
        } else {
            if (hi(t)) {
                return pi(t, t => Lt(t));
            }
            if (qc(t)) {
                return Lt(t.untrackedValue);
            }
        }
    }
    return null;
}

function Ft(t, n) {
    return nr(t) ? [ ...t, n ] : [ t, n ];
}

function Xt() {
    return new Ds("script", null, {
        hidden: ""
    }, null, 0, ":useOn");
}

function Dt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Wt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Dt(t[c], c, r, s);
    }
    return i;
}

function Vt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function zt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Gl(e);
    const f = X(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Jo(c, n, Wt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Ql(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Jo(c, n, Wt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Ql(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            Bl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return Jo(c, n, Wt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const m = d - h + 1;
    const _ = new Map;
    for (let t = h; t <= d; t++) {
        _.set(a[t], t - h);
    }
    const b = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < b.length; t++) {
        const s = b[t];
        const o = s.key;
        if (_.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            Bl(n, e, s, !0);
        }
    }
    const S = new Int32Array(m);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < m; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(m);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let A = d;
    let I = w;
    const M = () => {
        for (;A >= h; ) {
            const t = A - h;
            if (P[t] === 1) {
                I = g[S[t]];
                A--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = I === null ? e.lastChild === t : t.nextSibling === I;
                s || Vl(n, e, t, I);
                I = t;
                A--;
                continue;
            }
            let l = A;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = A - l + 1;
            const d = Jo(c, n, Wt(o, a, null, i, l, A), e, I, I, s, null, !0, f);
            return pi(d, () => {
                const t = Vt(e, I, u);
                I = t;
                A = l - 1;
                return M();
            });
        }
    };
    return M();
}

function Ut(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Wr);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Pc) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Rc(s, n, t);
                hi(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Bt(t, n) {
    const e = t.props ||= {};
    e[Wi] = n;
}

function Qt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[Vi] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[Vi] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = Cl(n, document, r, e);
    const u = $l(r) && i || r;
    const f = u === r ? null : c;
    jl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Ht(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Wi];
    }(t);
    if (!r) {
        return;
    }
    Bt(t, null);
    qc(r) && (r = r.value);
    return Ho(n, e, r, o, s, null);
}

function Jt(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, cr);
    if (r && !r.resolved) {
        return r.resolve().catch(n => {
            t.dirty &= -5;
            throw n;
        });
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, Dr) || null;
    return Gt(n, o, o, r, i, e, s);
}

function Yt(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[Ui] || null;
        e && delete n[Ui];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Gt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Gt(n, e, s, o, r, i, c) {
    const l = di(() => Go(n, e, s, o, r), s => {
        const o = n.getHostProp(e, br);
        return t(() => Ho(n, i, s, e, c, So(o)));
    }, t => {
        n.handleError(t, e);
    });
    if (hi(l)) {
        return l;
    }
    return;
}

function Zt(t, n, e, s, o, r = null) {
    n.push(Do(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Kt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Di] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        qc(e) && (e = e.value);
        const r = s.isConst;
        Zt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Di];
    })(t);
}

function tn(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Wr);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Pc && n.h & 16) {
            n.h &= -17;
            const t = n;
            Bo(t);
        }
    }
}

function nn(n, e) {
    n.dirty &= -33;
    const s = e.getHostProp(n, zi);
    if (!s) {
        return;
    }
    const o = s.ft;
    const r = We();
    r.$ = e;
    return pi(t(() => Fe.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Cc(e, s, o);
        }
    });
}

function en(t, n, e, s) {
    t.dirty &= -257;
    if (!__EXPERIMENTAL__.each) {
        return;
    }
    const o = t;
    const r = n.getHostProp(o, Dr) || null;
    if (!r) {
        return;
    }
    let i = ss(r, "items");
    qc(i) && (i = ua(i));
    const c = ss(r, "key$");
    const l = ss(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return zt(n, e, o, s, i, u, f);
    }
    return pi(c.resolve(), t => pi(l.resolve(), r => zt(n, e, o, s, i, t, r)));
}

let Zo = null;

const Ko = (t, n, e) => {
    Zo || (Zo = t.insertBefore);
    Zo.call(t, n, e);
};

function rn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const r = () => {
        if (s) {
            if (s.length === 1) {
                Ko(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                Ko(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let i = 0; i < t.length; i++) {
        const c = t[i];
        if (c instanceof Co) {
            if (n === c.parent && e === c.beforeTarget) {
                s || (s = []);
                s.push(c.target);
                o.add(c.target);
                continue;
            }
            if (!s) {
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (n === c.parent) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (o.has(c.target) || e && c.target === e || n && c.target === n) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            Ko(c.parent, c.target, c.beforeTarget);
            continue;
        }
        if (c instanceof Mo) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            c.target.remove();
            continue;
        }
        if (c instanceof No) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            const t = c.target;
            t.textContent = "";
            continue;
        }
        if (c instanceof xo) {
            c.target.nodeValue = c.text;
        } else if (c instanceof Oo) {
            const t = c.target;
            const e = c.attrName;
            const s = c.attrValue;
            const o = s != null ? P(e, s, c.scopedStyleIdPrefix) : null;
            const i = o == null || o === !1;
            if (tl(t, e)) {
                t[e] = nl(o);
            } else if (e === Kr) {
                n === t && r();
                t.innerHTML = o;
                t.setAttribute(qr, "html");
            } else {
                i ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : g(t, e, o, c.isSvg);
            }
        }
    }
    r();
}

const tl = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const nl = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const el = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.Un = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const rl = (t => () => queueMicrotask(t))(ln);

const sl = el(ln);

let ol = !1;

function sn() {
    if (!ol) {
        ol = !0;
        rl();
    }
}

function on() {
    if (!ol) {
        ol = !0;
        sl();
    }
}

function ln() {
    ol = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = s(); ) {
        if (cn(e, n)) {
            on();
            return;
        }
    }
}

function cn(t, n) {
    const e = Ue;
    const s = $(t);
    const r = s.promise;
    if (r) {
        return;
    }
    const i = s.container;
    if (!t.dirty) {
        un(i, t, s, e);
        return;
    }
    const c = s.journal ||= [];
    let u = null;
    for (;u = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(u.dirty & 1023)) {
            __EXPERIMENTAL__.pendingBoundary && q(u);
            d(i, s, hn(u, t, i));
            continue;
        }
        if (u.flags & 32) {
            if (u.dirty & 128) {
                tn(u, i);
            } else if (u.dirty & 64) {
                const n = an(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            }
            u.dirty &= -1024;
            d(i, s, hn(u, t, i));
            continue;
        }
        let e;
        try {
            if (u.dirty & 1) {
                e = Ut(u, i, s);
            } else if (u.dirty & 2) {
                e = Ht(u, i, c, t);
            } else if (u.dirty & 4) {
                e = Jt(u, i, c, t);
            } else if (u.dirty & 8) {
                e = Yt(u, i, c, t);
            } else if (u.dirty & 256) {
                e = en(u, i, c, t);
            } else if (u.dirty & 16) {
                Kt(u, c);
            } else if (u.dirty & 32) {
                e = nn(u, i);
            } else if (u.dirty & 64) {
                const n = an(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            } else {
                u.dirty & 512 && Qt(u, c);
            }
        } catch (t) {
            i.handleError(t, u);
        }
        if (e && hi(e)) {
            T(s, u);
            const n = e;
            s.promise = n;
            o(t, i);
            const r = u;
            n.catch(t => {
                s.promise === n && i.handleError(t, r);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                l(t, i);
                sn();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    un(i, t, s, e);
}

function un(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        u(n, t);
        s || function o(t, n) {
            const e = $(t);
            const s = e.journal;
            if (s && s.length > 0) {
                rn(s);
                e.journal = null;
            }
            const o = h(e);
            if (o) {
                for (let t = 0; t < o.length; t++) {
                    Sl(n, o[t]);
                }
            }
            (function r(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    Rc(s, t, s.ht);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.pendingBoundary) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.value = Math.max(0, e.value - 1);
            }
        })(e);
        (function i(t) {
            __EXPERIMENTAL__.pendingBoundary && t.props && Yr in t.props && gl(t, Yr, null);
        })(n);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                fn(t);
            });
            return;
        }
        fn(t);
    }
}

function fn(t) {
    t.dt();
}

function an(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        q(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = hn(o[0], s, t);
    d(t, n, i);
    return i;
}

function hn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && dn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.pendingBoundary && q(s);
    return hn(s, n, e);
}

function dn(t, n) {
    if (!A(n)) {
        return !1;
    }
    $n(n) || pn(t, n, 0);
    return !0;
}

function pn(t, n, e) {
    if ($n(n)) {
        sn();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        Xi.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    i(t, r);
    sn();
    return r;
}

function $n(t) {
    return (t.flags & 256) !== 0;
}

function yn(t, n) {
    if (!(n.flags & 1)) {
        let e;
        n.dirty & 16 && function s(t, n) {
            n.dirty &= -17;
            const e = n.getProp(Di);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                qc(e) && (e = e.value);
                const r = P(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, r);
            }
        }(t, n);
        n.dirty & 32 && (e = nn(n, t));
        n.dirty &= -1024;
        return e;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Wr);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Pc) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Rc(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        hi(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            if (!__EXPERIMENTAL__.each) {
                return;
            }
            const e = n;
            const s = t.getHostProp(e, Dr) || null;
            if (!s) {
                return;
            }
            let o = ss(s, "items");
            qc(o) && (o = ua(o));
            const r = await ss(s, "key$").resolve();
            const i = await ss(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const ll = [];

function wn(t) {
    for (let n = 0; n < ll.length; n++) {
        const e = ll[n];
        const s = ll[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function mn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return Ue;
    }()) {
        const e = yn(t, n);
        hi(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return e;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function t(n, e) {
            ll.push(n);
            let s = A(n);
            let o = n.slotParent || n.parent;
            for (;o; ) {
                const t = o.dirty & 1023;
                const r = $n(o);
                __EXPERIMENTAL__.pendingBoundary && (s ||= A(o) || (t ? I(o) : null));
                if (o === e || t) {
                    M(n, s);
                    wn(o);
                    if (r) {
                        const t = $(o);
                        t.position !== o && (t.position = n);
                    }
                    ll.length = 0;
                    return;
                }
                if (r) {
                    const t = $(o);
                    t.position !== o && (t.position = n);
                }
                ll.push(o);
                o = o.slotParent || o.parent;
            }
            ll.length = 0;
            ((t, ...n) => {
                const e = Ze(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, A(n) || I(c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if ($n(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = $(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        $n(n) ? M(n, A(n)) : function l(t) {
            ll.push(t);
            let n = A(t);
            let e = t.slotParent || t.parent;
            for (;e; ) {
                const s = $n(e);
                __EXPERIMENTAL__.pendingBoundary && (n ||= A(e) || (s ? I(e) : null));
                if (s) {
                    M(t, n);
                    wn(e);
                    ll.length = 0;
                    return !0;
                }
                ll.push(e);
                e = e.slotParent || e.parent;
            }
            M(t, n);
            ll.length = 0;
            return !1;
        }(n) || pn(t, n, 0);
    }
}

function vn(t, n) {
    t.push(n);
}

const cl = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const ul = t => {
    let n = null;
    return e => {
        n || (n = cl(e, t));
        return n.call(e);
    };
};

const fl = (t, n, e = null) => {
    const s = new Oi(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const al = t => {
    const n = new Oi(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const hl = (t, n) => {
    const e = new ji(-4084, null, null, null, null, t, n);
    return e;
};

const dl = () => {
    const t = new Ci(null, -4094, null, null, null, null, null, null);
    return t;
};

const pl = t => t instanceof xi;

const $l = t => (t.flags & 1) === 1;

const yl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const wl = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const ml = t => (t.flags & 4) === 4;

const vl = t => (t.flags & 2) === 2;

const _l = t => {
    const n = t.flags;
    return (n & 2) === 2 && bl(t, hr, null) !== null;
};

const zd = t => t;

const bl = (t, n, e) => {
    if ($l(t) || vl(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const gl = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const El = (t, n, e, s, o = null) => {
    if ($l(n)) {
        gl(n, e, s);
        vn(t, Do(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Sl = (t, n) => {
    const e = window;
    e && (e._qwikEv ||= []).push(n);
};

const kl = t => {
    if (t.key) {
        return;
    }
    const n = ec(t.node, Zr);
    n && (t.key = n);
};

const Rl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (qi(c)) {
                _n(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== Zr && c) {
                if (c.startsWith(qr)) {
                    const t = i.value;
                    t === "html" ? gl(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && gl(e, "value", s.value);
                } else {
                    const t = i.value;
                    gl(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        bl(e, zr, null) === null && bl(e, Ur, null) === null || (n.flags |= 64);
    }
};

const Pl = t => {
    if (t.bt === "_run") {
        const n = t.getCaptured()?.[0];
        if (lr(n)) {
            return n;
        }
    }
    return t;
};

function _n(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Pl(Xn(i[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function bn(t, n, e) {
    let s = Gl(n);
    for (;s; ) {
        if (ml(s)) {
            Al(t, s);
            e(s, n);
        } else {
            $l(s) ? e(s, n) : bn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function gn(t) {
    let n = t;
    if (ml(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Gl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const Tl = (t, n, e) => {
    let s = t;
    for (;e && s && vl(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !vl(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !vl(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (ml(t) && e && $l(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && mc(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Al = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = zl(n, !0);
        const o = e.node;
        const r = hc(s);
        let i = Tl(n, !1, !0);
        const c = Tl(n, !0, !0);
        const l = o || (c && $l(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && ml(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                vn(t, Xo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Tl(i, !1, !0);
        }
        i = n;
        for (;i && ml(i); ) {
            const n = Tl(i, !0, !0);
            const e = !n || !ml(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    vn(t, Fo(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    vn(t, Xo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const ql = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const e = t.vNode;
        if (e) {
            return e;
        }
    }
    if (pl(i)) {
        e = i;
    } else {
        let t = i;
        const n = [ i ];
        for (;t && t !== s && !t.vNode; ) {
            t = t.parentElement;
            n.push(t);
        }
        t.vNode && (e = t.vNode);
        for (let t = n.length - 2; t >= 0; t--) {
            e = Nl(e, n[t]);
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = xl(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = Il(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const Il = (t, n) => {
    let e = Gl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Ml = [];

const Nl = (t, n) => {
    let e = Gl(t);
    for (;e && (!(e instanceof Oi) || e.node !== n); ) {
        if (vl(e)) {
            const t = e.nextSibling;
            const n = Gl(e);
            if (n) {
                t && Ml.push(t);
                e = n;
            } else {
                e = t || (Ml.length ? Ml.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Ml.pop();
        }
    }
    for (;Ml.length; ) {
        Ml.pop();
    }
    return e;
};

const xl = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Cl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = fl(o, "errored-host");
    if (yl(e)) {
        Vl(t, r, e, null);
    } else {
        const n = [];
        bn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Vl(t, r, n[e], null);
        }
    }
    return r;
};

const Ol = rn;

const jl = (t, n, e, s) => {
    const o = $l(n);
    o && Zl(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Dl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : zl(n, !1);
    l && !c && vn(t, Xo(i, l, Fl(t, n, s)?.node ?? null));
    Xl(n, e, s);
    c && (e.flags |= 32);
};

const Ll = (t, s, o, r) => {
    const i = $l(s);
    i && Zl(s);
    const c = o.parent;
    if (o === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Dl(t, c, s, o);
    const l = s.flags & 32;
    const u = !i && s.flags & 2048 ? s.props?.[fr] : null;
    const f = u ? null : i ? s : Ul(s, !1);
    const a = u || f?.node;
    const h = Fl(t, s, r);
    const d = h?.node ?? null;
    const p = _l(o);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Ul(s, !1);
        const c = Fl(t, s, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = e(i, o);
        bn(t, o, s => {
            if (ml(s)) {
                vn(t, Xo(s.node, a, c));
            } else {
                if ((s.flags & 1536) !== u) {
                    const t = function o(t, s, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let o = null;
                            let a = null;
                            if ($l(c)) {
                                o = c.node;
                                const t = Hl(c);
                                const l = c.parent;
                                const h = u == null ? s : l && Ul(l, !0);
                                if (h) {
                                    const t = e(h, Hl(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = Gl(c);
                                a = n(o, t, r, !d);
                                o.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (tc(o)) {
                                    const t = xe(o);
                                    if (t) {
                                        const n = Gl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(s, i, l, u);
                    t && (s.node = t);
                }
                vn(t, Xo(s.node, a, c));
            }
        });
    } else {
        a && !l && bn(t, o, n => {
            vn(t, Xo(n.node, a, d));
        });
    }
    Xl(s, o, r);
    l && (o.flags |= 32);
};

const Fl = (t, n, e) => {
    let s = null;
    e == null ? vl(n) && (s = Tl(n, !0, !1)) : s = vl(e) ? Tl(e, !0, !0) : e;
    s && ml(s) && Al(t, s);
    return s;
};

const Xl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Dl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && Bl(t, n, s, !1);
};

const Wl = (t, n) => {
    let e = n;
    for (;e && vl(e); ) {
        e = e.lastChild;
    }
    e && ml(e) && (e.flags & 8) === 0 && Al(t, e);
};

const Vl = (t, n, e, s) => {
    yl(e) ? jl(t, n, e, s) : Ll(t, n, e, s);
};

const zl = (t, n) => {
    for (;t && !$l(t); ) {
        if (t.flags & 2048) {
            return t.props?.[fr];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Ul = (t, n) => {
    for (;t && !$l(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const Bl = (t, n, e, s) => {
    ml(e) && Al(t, e);
    if (s) {
        const s = bl(n, Kr, null) !== null;
        if (s) {
            return;
        }
        yl(e) ? vn(t, jo(e.node)) : bn(t, e, n => {
            vn(t, jo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Ql = (t, n, e, s = !0) => {
    const o = zl(n, !0);
    if (o && s) {
        if (yl(n)) {
            vn(t, Lo(n.node));
        } else {
            const e = Ul(n, !1);
            e && e.firstChild === n && e.lastChild === n ? vn(t, Lo(o)) : bn(t, n, n => {
                vn(t, jo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Hl = t => {
    const n = zd(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = ac(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = fc(t);
            switch (n) {
              case Cr:
                return 512;

              case Or:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Jl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Yl = (t, n, e) => {
    Al(t, n);
    n.text = e;
    vn(t, Fo(n.node, e));
};

const Gl = t => {
    if (ml(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.pendingBoundary && n === void 0 && $l(t) && function e(t) {
        const n = t.getAttribute(Dd);
        if (n === null) {
            return !1;
        }
        const e = uc(t);
        return Ec(e) && e.localName === "template" && e.getAttribute(yr) === n && oc(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Zl(t));
    return n;
};

const Zl = t => {
    const n = zd(t);
    let e = n.firstChild;
    if (e === void 0) {
        const t = n.node;
        e = n.parent && tc(t) ? n.firstChild = n.lastChild = null : (t => {
            const n = t.node;
            const e = uc(n);
            const s = hc(n)?.qVNodeData?.get(n);
            const o = ((t, n, e, s) => {
                kl(t);
                __EXPERIMENTAL__.pendingBoundary && n._qSegment;
                if (s) {
                    if (s.charCodeAt(0) === Si && s.charCodeAt(1) === Si) {
                        const n = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(s);
                        const o = n.elementVNodeData;
                        s = n.virtualVNodeData;
                        const r = dc(t, e, o);
                        if (!s) {
                            return r;
                        }
                    }
                    return function o(t, n, e, s) {
                        let o = 0;
                        let r = null;
                        let i = null;
                        let c = null;
                        const l = n => {
                            n.flags = n.flags & 4095 | o << 12;
                            o++;
                            i && (i.nextSibling = n);
                            n.previousSibling = i;
                            n.parent = t;
                            r || (t.firstChild = r = n);
                            i = n;
                        };
                        let u = 0;
                        let f = null;
                        let a = null;
                        const h = t => {
                            const n = Ec(t);
                            return !n || n && Rn(t);
                        };
                        let d = null;
                        pc(n, (p, $, y, w, m, _) => {
                            if (vc(p())) {
                                for (;h(s); ) {
                                    s = oc(s);
                                    if (!s) {
                                        throw ir(27, [ n, p(), m ]);
                                    }
                                }
                                f = null;
                                c = null;
                                let t = 0;
                                for (;vc(p()); ) {
                                    t *= 10;
                                    t += y() - 48;
                                }
                                for (;t--; ) {
                                    const e = al(s);
                                    kl(e);
                                    l(e);
                                    s = oc(s);
                                    for (;Ec(s) && Rn(s); ) {
                                        s = oc(s);
                                        if (!s && t > 0) {
                                            throw ir(27, [ n, p(), m ]);
                                        }
                                    }
                                }
                            } else if (p() === 59) {
                                gl(t, br, $());
                            } else if (p() === 60) {
                                const n = $();
                                if (n.charCodeAt(0) === 95) {
                                    gl(t, ur, decodeURIComponent(E(n.slice(1))));
                                } else {
                                    (d ||= []).push(t);
                                    gl(t, cr, n);
                                }
                            } else if (p() === 61) {
                                a || (a = Ne(e));
                                const n = $();
                                a.Hn(parseInt(n, 10), t);
                            } else if (p() === 62) {
                                gl(t, Dr, $());
                            } else if (p() === 64) {
                                t.key = _();
                            } else if (p() === 91) {
                                gl(t, Wr, $());
                            } else if (p() === 94) {
                                gl(t, Vr, $());
                            } else if (p() === 96) {
                                a || (a = Ne(e));
                                Sn(t, $(), a);
                            } else if (p() === 63) {
                                a || (a = Ne(e));
                                t.slotParent = ql(a.rootVNode, $());
                            } else if (p() === 93) {
                                gl(t, gr, $());
                            } else if (p() === 123) {
                                y();
                                l(dl());
                                bc.push(t, r, i, c, o);
                                o = 0;
                                t = i;
                                r = i = null;
                            } else if (p() === Si) {
                                const n = $();
                                const e = decodeURIComponent(E(n));
                                const s = m + n.length + 1;
                                const o = w(s + 1) === Si;
                                let r;
                                if (o) {
                                    y();
                                    r = decodeURI(E($()));
                                    y();
                                } else {
                                    r = E($());
                                }
                                gl(t, e, r);
                            } else if (p() === 125) {
                                y();
                                t.lastChild = i;
                                o = bc.pop();
                                c = bc.pop();
                                i = bc.pop();
                                r = bc.pop();
                                t = bc.pop();
                            } else if (p() === 126) {
                                gl(t, hr, _());
                            } else {
                                for (;Ec(s) && Rn(s); ) {
                                    s = oc(s);
                                }
                                const t = s && rc(s) === 3 ? s : null;
                                if (f === null) {
                                    f = t ? t.nodeValue : null;
                                    u = 0;
                                }
                                let n = 0;
                                for (;_c(p()); ) {
                                    n += y() - 97;
                                    n *= 26;
                                }
                                n += y() - 65;
                                const e = f === null ? "" : f.substring(u, u + n);
                                l(c = ((t, n, e) => {
                                    const s = new ji(-4092, null, t, null, null, n, e);
                                    return s;
                                })(c, t, e));
                                u += n;
                            }
                        });
                        if (d) {
                            a || (a = Ne(e));
                            for (let t = 0; t < d.length; t++) {
                                a.ensureProjectionResolved(d[t]);
                            }
                            d = null;
                        }
                        t.lastChild = i;
                        return r;
                    }(t, s, n, e);
                }
                return dc(t, e, void 0);
            })(t, n, e, s);
            return o;
        })(n);
    }
    return e;
};

let Kl = null;

const tc = t => {
    Kl || (Kl = t.hasAttribute);
    return Kl.call(t, qr);
};

let nc = null;

const ec = (t, n) => {
    nc || (nc = t.getAttribute);
    return nc.call(t, n);
};

const rc = ul("nodeType");

const ic = t => {
    const n = rc(t);
    return n === 3 || n === 1;
};

let sc = null;

const oc = t => {
    sc || (sc = cl(t, "nextSibling"));
    cc || (cc = cl(t, "firstChild"));
    for (;t; ) {
        t = sc.call(t);
        if (t !== null) {
            const n = rc(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Tr)) {
                    return En(t, Rr, sc, cc);
                }
                if (t.nodeValue?.startsWith(Pr)) {
                    return En(t, [ Rr, Ar ], sc, cc);
                }
                if (n?.startsWith(qr)) {
                    for (;t && (t = sc.call(t)) && (rc(t) !== 8 || !t.nodeValue?.startsWith(Ir)); ) {}
                }
            }
        }
    }
    return t;
};

function En(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = lc(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const lc = ul("parentNode");

let cc = null;

const uc = t => {
    cc || (cc = cl(t, "firstChild"));
    t = t && cc.call(t);
    if (t && rc(t) === 8) {
        sc || (sc = cl(t, "nextSibling"));
        if (t.nodeValue?.startsWith(Tr)) {
            return En(t, Rr, sc, cc);
        }
    }
    for (;t && !ic(t); ) {
        t = oc(t);
    }
    return t;
};

const fc = ul("namespaceURI");

const ac = ul("nodeName");

const hc = ul("ownerDocument");

const dc = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;Ec(i) && Rn(i); ) {
            i = oc(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = rc(i);
        let e = null;
        if (n === 3) {
            e = hl(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = al(i);
            kl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = oc(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        pc(e, (e, s) => {
            if (e() === 61) {
                n || (n = Ne(t.node));
                const e = s();
                n.Hn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Ne(t.node));
                Sn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function Sn(t, n, e) {
    if (t[mi]) {
        const s = t[mi];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e.k(n));
    } else {
        Object.defineProperty(t, mi, {
            get() {
                const s = e.k(n);
                t[mi] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, mi, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const pc = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    const u = () => {
        if (r(e + 1) !== Si) {
            return l();
        }
        c();
        const t = decodeURIComponent(E(l()));
        c();
        return t;
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e, u);
    }
};

const $c = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Rl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(Zr) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const yc = (t, n) => {
    let e = wc(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = wc(e);
    }
    return !1;
};

const wc = t => t.parent || t.slotParent;

const mc = t => {
    if (t === null || vl(t)) {
        return null;
    }
    return t.node;
};

function kn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if ($l(e)) {
                        const t = Ce(e.node);
                        if (!t) {
                            return null;
                        }
                        return xe(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (ml(i)) {
            c.push(Nn(Jl(i)));
        } else if (vl(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = $c(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== _i && e !== "__scopedStyleIdPrefix__") {
                        const t = bl(i, e, null);
                        s.push(" " + e + "=" + Nn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (bi[bl(i, _i, null) || "V"] || bi.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Gl(i);
            u && c.push("  " + kn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if ($l(i)) {
            const s = Hl(i);
            const l = [];
            $n(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? $c(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = bl(i, n, null);
                l.push(" " + n + "=" + Nn(e));
            }
            const f = mc(i);
            if (f) {
                const t = hc(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Nn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Nn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (wl(i) || e) {
                const e = Gl(i);
                e && c.push("  " + kn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const vc = t => 48 <= t && t <= 57;

const _c = t => 97 <= t && t <= 122;

function Rn(t) {
    return !t.hasAttribute(Zr) || t.nodeName === "STYLE" && (t.hasAttribute(br) || t.hasAttribute(mr));
}

const bc = [];

const gc = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw ir(26, [ n ]);
};

const Ec = t => t && typeof t == "object" && rc(t) === 1;

const Sc = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!vl(t) || bl(t, cr, null) === null); ) {
            const e = t.slotParent;
            const s = vl(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function Pn(t, n) {
    pl(n) && $l(n) && Zl(n);
    const e = n[mi];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Tn(t, n);
    }
    e.clear();
}

function Tn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof $s) {
            An(t, s, n);
            s instanceof ws && qn(s, n);
        } else if (cs(s)) {
            const t = s[Yi];
            In(t, n);
        } else if (t.$t.has(s)) {
            const e = t.$t.get(s);
            const o = Wc(e);
            In(o, n);
        }
    }
    e.clear();
}

function An(t, n, e) {
    const s = n.ft;
    s && s.has(e) && s.delete(e);
    if (n instanceof Ls && !s?.size) {
        n._ = void 0;
        Pn(t, n);
    }
}

function qn(t, n) {
    const e = t.yt;
    e && e.has(n) && e.delete(n);
    const s = t.wt;
    s && s.has(n) && s.delete(n);
    t.vt();
}

function In(t, n) {
    const e = t?.ft;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const kc = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Wo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Pc(6 | i, r, o._, t, null);
    s(c);
    const l = o.$;
    const {dn: u} = o;
    const f = pi(u, () => Rc(c, l, o._));
    hi(f) && (o.dn = f);
};

const Rc = (t, n, e) => {
    const s = t.Jn;
    if (s) {
        return s;
    }
    const o = t => {
        Xf(t, "hook");
        n.handleError(t, e, "hook");
    };
    let r = null;
    const i = pi(((t, n) => {
        const e = t.Yn;
        if (e) {
            return e;
        }
        const s = t.Un;
        if (!s) {
            return;
        }
        t.Un = null;
        try {
            const e = s();
            if (hi(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Yn === s && (t.Yn = void 0);
                });
                t.Yn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        t.h = t.h & -5 | 64;
        const s = We(n.fn, e, "qTask");
        s.$ = n;
        const i = t._t.getFn(s, () => Pn(n, t));
        const c = ps(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.Un = () => {
                            t.Un = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    hi(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return di(() => i(u), l, s => {
            if (hi(s)) {
                return s.then(() => {
                    t.Jn === r && (t.Jn = null);
                    return Rc(t, n, e);
                }, o);
            }
            o(s);
        });
    });
    if (hi(i)) {
        r = i.finally(() => {
            if (t.Jn === r) {
                t.Jn = null;
                t.h & 4 && mn(n, e, 1);
            }
        });
        t.Jn = r;
        return r;
    }
    return i;
};

class Pc extends vi {
    h;
    Xt;
    ht;
    _t;
    Un;
    Yn;
    Jn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Xt = n;
        this.ht = e;
        this._t = s;
        this.Un = o;
    }
}

const Tc = t => t instanceof Pc;

function Mn(t, n) {
    const e = Ne(n);
    return na(e, () => {
        typeof this === "string" && Pa(Ta(e, this));
        const t = Ra[0];
        if (!t.ht) {
            return;
        }
        if (t.h & 68) {
            return;
        }
        t.h |= 4;
        mn(e, t.ht, 1);
    });
}

const Ac = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const qc = t => t instanceof $s;

const Ic = (t, n) => {
    t.add(n);
};

const Mc = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Nc = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Tc(e) ? o = e._t : e instanceof ws ? o = e.Wt : s === ":" && (o = n.getHostProp(e, cr));
        o && n.serializationCtx.Ft.add(o);
    }
};

const xc = (t, n) => {
    if (t && (!n || t === n || Vd(t))) {
        return t;
    }
    return n;
};

const Cc = (t, n, e) => {
    const s = Be;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Tc(o)) {
                o.h |= 4;
                mn(t, o.ht, 1);
            } else if (o instanceof $s) {
                o.invalidate();
            } else if (r === ":") {
                mn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Bt(o, n);
                    mn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Fs) {
                    const e = i.data;
                    const c = {
                        isConst: e.rt,
                        scopedStyleIdPrefix: e.j,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Di];
                            if (!o) {
                                o = new Map;
                                s[Di] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Di);
                        if (!n) {
                            n = new Map;
                            t.setProp(Di, n);
                        }
                        n.set(r, c);
                    }
                    mn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Oc = (t, n, e = new Set) => {
    if (!t) {
        return;
    }
    for (const s of t) {
        const t = s.consumer;
        if (Tc(t)) {
            n.push(t.ht);
        } else if (t instanceof ws) {
            if (!e.has(t)) {
                e.add(t);
                Oc(t.ft, n, e);
                Oc(t.wt, n, e);
                Oc(t.yt, n, e);
            }
        } else if (t instanceof $s) {
            const s = t;
            s._ ? n.push(s._) : Oc(s.ft, n, e);
        } else {
            n.push(t);
        }
    }
};

const jc = t => tr(t) && typeof t[Ef] === "function";

const Lc = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Fc = t => {
    t.h |= 4;
};

const Xc = [];

function Nn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Tc(t)) {
            return `Task(${Nn(t._t)})`;
        }
        if (lr(t)) {
            return `Qrl(${t.bt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Xc.includes(t)) {
                return "*";
            }
            Xc.length;
            try {
                Xc.push(t);
                if (Array.isArray(t)) {
                    return pl(t) ? "(" + (bl(t, _i, null) || "vnode") + ")" : t.map(Nn);
                }
                if (qc(t)) {
                    return t instanceof Ls ? "WrappedSignal" : t instanceof ws ? "ComputedSignal" : "Signal";
                }
                if (Qc(t)) {
                    return "Store";
                }
                if (Vs(t)) {
                    return Dc(t);
                }
                if (pl(t)) {
                    return "(" + (bl(t, _i, null) || "vnode") + ")";
                }
            } finally {
                Xc.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Dc = t => {
    if (Vs(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Ua];
            if (n) {
                const [t] = n;
                return "Component(" + t.bt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + Nn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Dc(e);
                    }
                } else {
                    n += Dc(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Wc = t => t[hs];

const Vc = t => {
    try {
        return t?.[as] || null;
    } catch {
        return null;
    }
};

const zc = (t, n) => {
    const e = Wc(t);
    e && e.force(n);
};

const Uc = (t, n) => {
    const e = Wc(t);
    if (e) {
        return (e.ft?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Bc = t => Vc(t) || t;

const Qc = t => as in t;

function xn(t, n, e) {
    return new Proxy(n, new Jc(e, t || null));
}

const Hc = (t, n, e) => {
    if (Ke(t) && e) {
        let s = e.$t.get(t);
        if (!s) {
            s = xn(e, t, n);
            e.$t.set(t, s);
        }
        return s;
    }
    return t;
};

class Jc {
    h;
    $;
    ft=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Vc(this);
        Cc(this.$, this, jn(n, t, this.ft));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === as) {
                return t;
            }
            if (n === hs) {
                return this;
            }
            return t[n];
        }
        const e = sa();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.hn;
            o && Cn(t, Array.isArray(t) ? ds : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        let r = !1;
        if (o & 1 && tr(s)) {
            try {
                r = !Object.isFrozen(s) && !Qc(s) && !Object.isFrozen(t);
            } catch {}
        }
        if (r) {
            return Hc(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Bc(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && On(n, s, t, this);
        } else {
            On(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Cc(this.$, this, jn(t, n, this.ft));
        return !0;
    }
    has(t, n) {
        if (n === as) {
            return !0;
        }
        if (typeof n === "string") {
            const e = sa();
            if (e) {
                const s = e.hn;
                s && Cn(t, Array.isArray(t) ? ds : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = sa();
        const e = n?.hn;
        e && Cn(t, ds, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Cn(t, n, e, s, o) {
    const r = e.ft ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = Ue;
    const l = __EXPERIMENTAL__.pendingBoundary && e instanceof Jc && c;
    Ic(i, s);
    Mc(s, t);
    if (c) {
        const i = xc(o, e.$);
        l && i?.mn?.(t, s, n, r);
        Nc(s, i);
    }
}

function On(t, n, e, s) {
    e[t] = n;
    const o = jn(e, t, s.ft);
    o && Cc(s.$, s, o);
}

function jn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(ds);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Yc = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const Gc = '"';

const Zc = "[";

const Kc = "]";

const tu = ",";

const nu = Symbol();

const eu = [ void 0, null, !0, !1, "", Ki, ts, us, ds, Zi, fo, co, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const ru = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const iu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function Ln(t, n, e) {
    let s = n.bt;
    let o = n.gt;
    const r = si();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => lr(t) && t.bt == or)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.Et(null, 0, e) + "";
    } else {
        o || (o = t.St(n.ot));
        if (!o) {
            throw ir(14, [ n.bt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.kt(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function Fn(t, n, e, s) {
    return Ma(t, n, null, null, e, s);
}

function Xn(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return Fn(o, r, i, n);
}

class su {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class ou {
    Gn;
    Zn=0;
    Pt=[];
    Kn=0;
    te=new Set;
    ne=new Map;
    ee;
    re=new Map;
    ie=0;
    se=new WeakSet;
    Yt;
    oe=typeof Temporal !== "undefined";
    constructor(t) {
        this.Gn = t;
        this.Yt = t.Yt;
    }
    async serialize() {
        const t = this.ie;
        this.ie = 0;
        this.se = new WeakSet;
        try {
            await this.outputRoots();
        } finally {
            this.ie = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.ie;
        this.ie = s;
        this.se = new WeakSet;
        this.Yt.write(Zc);
        this.Gn.le = 0;
        try {
            this.Yt.write(t + "");
            this.Yt.write(tu);
            this.Yt.write(Zc);
            await this.outputSelectedRoots(n);
            this.Yt.write(Kc);
            const s = this.getForwardRefsPayload();
            this.Gn.le = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Yt.write(tu);
                s ? this.outputForwardRefsArray(s) : this.Yt.write("0");
            }
            if (e !== void 0) {
                this.Yt.write(tu);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Yt.write(Gc);
                    this.writeRootRefPath(e);
                    this.Yt.write(Gc);
                }
            }
        } finally {
            this.ie = o;
        }
        this.Yt.write(Kc);
    }
    ce(t) {
        this.Yt = t;
    }
    outputArray(t, n, e) {
        this.Yt.write(Zc);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Yt.write(tu) : s = !0;
            e(t[n], n);
        }
        this.Yt.write(Kc);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : Gc + t + Gc;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Yt.write(n.slice(s, e));
            this.Yt.write("<\\/");
            s = e + 2;
        }
        this.Yt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Yt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Yt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Yt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Yt.write(Gc);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Yt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Yt.write(Gc);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Yt.write(t + tu);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Yt.write(Gc);
                this.writeRootRefPath(n);
                this.Yt.write(Gc);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Yt.write(t + tu);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Yt.write(t + tu + n);
        } else if (typeof n === "string") {
            this.Yt.write(t + tu);
            this.outputString(n);
        } else {
            this.Yt.write(t + tu);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Gn.getSeenRef(t);
        const o = !e && this.ne.get(t);
        if (s) {
            s.ee && this.isSeenInStreamedRoot(s) && (s = this.Gn.ue(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Gn.fe(t, this.ee, n);
            }
            s = this.Gn.kt(t, !0);
        }
        if (s.ee) {
            if (this.ee) {
                this.Gn.ae(s, t);
            } else {
                this.Gn.ae(s, t, n);
                t = this.Gn.he[n];
            }
        }
        if (typeof o === "number") {
            this.Pt[o] = s.Xt;
            this.ne.delete(t);
        }
        const r = t instanceof yu ? t.de : s.Xt;
        if (!this.ee && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.ee; ) {
            t = t.ee;
        }
        return t.Xt < this.ie;
    }
    writeValue(t, n) {
        if (_f(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === us) {
                    this.output(3, 7);
                } else if (t === ds) {
                    this.output(3, 8);
                } else if (t === Zi) {
                    this.output(3, 9);
                } else {
                    if (t !== nu) {
                        throw ir(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === fo) {
                    this.output(3, 10);
                } else if (t === co) {
                    this.output(3, 11);
                } else if (lr(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = Ln(this.Gn, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.Gn.kt(n);
                            const i = this.Gn.kt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.re.get(l);
                            if (u) {
                                const t = this.Gn.kt(u);
                                this.output(1, t);
                                return;
                            }
                            this.re.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!Ba(t)) {
                        throw ir(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[Ua];
                        this.Gn.pe.add(n.bt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Ki) {
                    this.output(3, 5);
                } else if (t === ts) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof yu) {
                    this.output(1, t.de);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.ee;
                        this.ee = e;
                        this.writeObjectValue(t);
                        this.ee = n;
                    }
                }
                break;

              default:
                throw ir(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (cs(t)) {
            const n = t[Ji];
            this.output(38, [ pu(n), n.varProps, n.constProps, t[Yi].ft ]);
        } else if (t instanceof Fs) {
            const {j: n, rt: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof fs) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof su) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (Qc(t)) {
            const n = Wc(t);
            const e = Vc(t);
            const s = n.h;
            const o = n.ft;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Gn.$t.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (jc(t)) {
            const n = t[Ef](t);
            if (hi(n)) {
                const t = this.resolvePromise(n, (t, n) => new lu(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.ee.Xt;
                this.ee = this.ee.ee;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        _f(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Gn.$e(t)) {
            this.Gn.ye(t.we, 16);
            this.output(11, t.we.id);
        } else if (t instanceof $s) {
            if (t instanceof Es) {
                const n = function e(t, n) {
                    if (n === us) {
                        return n;
                    }
                    return pi(t.Wt.resolved || t.Wt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && Ef in n && (e = n[Ef](n));
                        e === void 0 && (e = us);
                        return e;
                    });
                }(t, t.Dt);
                if (hi(n)) {
                    const e = this.resolvePromise(n, (n, e) => new lu(34, n, e, t.ft, t.Wt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Wt, t.ft, n ]);
                }
                return;
            }
            if (t instanceof Ls) {
                this.output(31, [ ...Dn(this.Gn, t), t.h, t._, ...t.ft || [] ]);
            } else if (t instanceof ws) {
                let n = t.Dt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = _f(t.Dt);
                const i = !!(t.h & 512);
                const c = i && !!t.Vt;
                const l = i && t.Ut !== 1 ? t.Ut : void 0;
                const u = i && t.Qt !== 0 ? t.Qt : void 0;
                const f = i && t.h & -25 || void 0;
                o || r || c ? n = us : e ? n = t.Dt : s && (n = us);
                const a = [ t.Wt, t.ft ];
                if (i) {
                    const n = t.Vt;
                    a.push(t.yt, t.wt, n === void 0 ? n : Nf(n));
                    a.push(f || void 0);
                }
                n === us && l === void 0 && u === void 0 || a.push(n === void 0 ? nu : n);
                if (i) {
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Dt;
                const e = [ n === void 0 ? nu : n ];
                t.ft && e.push(...t.ft);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            for (const e of Object.entries(t)) {
                n.push(e[0], e[1]);
            }
            this.output(23, n);
        } else if (this.Gn.me(t)) {
            if (t.vnodeData && t.vnodeData[0] & 32 && /[A-Za-z]/.test(t.id)) {
                this.output(3, 0);
                return;
            }
            const n = this.Gn.kt(t);
            this.Gn.ve(t, Fr, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                if (!this.se.has(e)) {
                    this.se.add(e);
                    cu(e, this.Gn);
                }
                this.Gn.ye(t, 16, !0);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Gn.ye(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Vs(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Pc) {
            const n = [ t._t, t.h, t.Xt, t.ht ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (hi(t)) {
            const n = this.resolvePromise(t, (t, n) => new lu(24, t, n));
            this.output(2, n);
        } else if (t instanceof lu) {
            if (t._e === 34) {
                if (t._t) {
                    this.output(34, [ t._t, t.ft, t.be ]);
                } else {
                    if (!t.ge) {
                        console.error(t.be);
                        throw ir(33);
                    }
                    {
                        const n = this.ee.Xt;
                        this.ee = this.ee.ee;
                        this.writeValue(t.be, n);
                    }
                }
            } else {
                this.output(24, [ t.ge, t.be ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof du) {
            const n = t.Ee;
            if (this.getSeenRefOrOutput(n, this.ee.Xt, !0)) {
                let t = this.ne.get(n);
                if (t === void 0) {
                    t = this.Kn++;
                    this.ne.set(n, t);
                    this.Pt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.oe && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.oe && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.oe && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!pl(t)) {
                throw ir(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Kn++;
        t.then(s => {
            this.te.delete(t);
            this.Pt[e] = this.Gn.kt(n(!0, s));
        }).catch(s => {
            this.te.delete(t);
            this.Pt[e] = this.Gn.kt(n(!1, s));
        });
        this.te.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Gn.Se + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {he: n} = this.Gn;
        for (;this.Zn < n.length || this.te.size; ) {
            let e = t > 0;
            for (;this.Zn < n.length; this.Zn++) {
                e ? this.Yt.write(tu) : e = !0;
                this.writeValue(n[this.Zn], this.Zn);
                t++;
            }
            if (this.te.size) {
                try {
                    await Promise.race(this.te);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.te.size; ) {
            if (e < t.length) {
                n ? this.Yt.write(tu) : n = !0;
                const s = t[e++];
                this.writeValue(this.Gn.he[s], s);
                continue;
            }
            try {
                await Promise.race(this.te);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Pt.length - 1;
        for (;t >= 0 && this.Pt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Pt.length - 1 ? this.Pt : this.Pt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Yt.write(Gc);
                this.writeRootRefPath(t);
                this.Yt.write(Gc);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Yt.write(Zc);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Gn.ke = this.Gn.he.length;
        this.Gn.Re = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Yt.write(tu);
            this.Yt.write(14 + tu);
            this.outputForwardRefsArray(n);
        }
        this.Yt.write(Kc);
        this.Gn.Pe = this.Gn.he.length + (this.Gn.Re ? 1 : 0);
        this.Gn.le = e;
    }
}

class lu {
    _e;
    ge;
    be;
    ft;
    _t;
    constructor(t, n, e, s, o) {
        this._e = t;
        this.ge = n;
        this.be = e;
        this.ft = s;
        this._t = o;
    }
}

const cu = (t, n) => {
    const e = t.length;
    for (let s = 1; s < e; s++) {
        const e = t[s];
        if (uu(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === Fr || t === Dr && (Xs(s) || fu(e, s))) {
                    continue;
                }
                n.kt(s);
            }
        }
    }
};

const uu = t => typeof t === "object" && t !== null && !Xs(t);

const fu = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, cr)) {
        return !1;
    }
    const s = n[Ji];
    return Xs(s.varProps) && !au(n) && !hu(t[Er]);
};

const au = t => !!t[Yi].ft?.size;

const hu = t => t instanceof Map && t.has(":");

function Dn(t, n) {
    n.Rt && n.Rt[0] === "{" && (n.Rt = `(${n.Rt})`);
    const e = t.Et(n.Rt, n.ct.length, n.lt);
    return [ e, n.ct ];
}

class du {
    Ee;
    constructor(t) {
        this.Ee = t;
    }
}

const pu = t => new du(t);

let $u = () => !1;

class yu {
    de;
    constructor(t) {
        this.de = t;
    }
}

class wu {
    NodeConstructor;
    DomRefConstructor;
    St;
    ve;
    $t;
    Yt;
    Te=new Map;
    Ae=new Map;
    qe=0;
    Ie=[];
    he=[];
    Me=[];
    Ne;
    Se=0;
    Pe=0;
    le=0;
    ke=0;
    Re=!1;
    xe=new Set;
    Ft=new Set;
    Lt=new Set;
    pe=new Set;
    Ce;
    ye=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.St = e;
        this.ve = s;
        this.$t = o;
        this.Yt = r;
        this.Ce = new ou(this);
    }
    async Jt() {
        await this.Ce.serialize();
    }
    async Oe(t, n, e, s) {
        await this.Ce.serializePatch(t, n, e, s);
    }
    ce(t) {
        this.Yt = t;
        this.Ce.ce(t);
    }
    getSeenRef(t) {
        return this.Te.get(t);
    }
    fe(t, n, e) {
        const s = {
            Xt: e,
            ee: n
        };
        this.Te.set(t, s);
        return s;
    }
    je(t) {
        const n = [];
        for (;t.ee; ) {
            n.unshift(t.Xt);
            t = t.ee;
        }
        n.unshift(t.Xt);
        return n;
    }
    ae(t, n, e) {
        const s = this.je(t);
        const o = e === void 0;
        e === void 0 && (e = this.he.length);
        this.he[e] = new yu(s);
        o && (this.Me[e] = n);
        t.ee = null;
        t.Xt = e;
        o && this.Ne?.(e, this.he[e], n);
    }
    kt(t, n = !1) {
        let e = this.Te.get(t);
        let s;
        if (e) {
            e.ee && this.ae(e, t);
            s = e.Xt;
        } else {
            s = this.he.length;
            e = {
                Xt: s
            };
            this.Te.set(t, e);
            this.he.push(t);
            this.Me.push(t);
            this.Ne?.(s, t, t);
        }
        return n ? e : s;
    }
    ue(t) {
        const n = this.he.length;
        const e = {
            Xt: n
        };
        this.Te.set(t, e);
        this.he.push(t);
        this.Me.push(t);
        this.Ne?.(n, t, t);
        return e;
    }
    Le(t, n) {
        const e = this.he.length;
        const s = {
            Xt: e
        };
        this.Te.set(n, s);
        this.he.push(t);
        this.Me.push(n);
        return e;
    }
    me(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    $e(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Fe(t) {
        const n = this.Te.get(t);
        return n && (n.ee ? void 0 : n.Xt);
    }
    Et(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.Ae.get(t);
        if (o === void 0) {
            o = this.qe + this.Ie.length;
            this.Ae.set(t, o);
            if (s) {
                this.Ie.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Ie.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Xe(t, n) {
        this.qe = t;
        if (n) {
            this.Ae.clear();
            for (let t = 0; t < n.length; t++) {
                this.Ae.set(n[t], t);
            }
        }
    }
}

const Ud = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(Yc(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    $u = n ? t => t instanceof n : () => !1;
    return new wu(t, n, e, s, o, r);
};

const mu = (t, n) => t[n];

const vu = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        Qc(t) && (t = Vc(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!vu(ua(mu, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!vu(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Tc(t)) {
            return !0;
        }
        if (cs(t)) {
            return !0;
        }
        if (hi(t)) {
            return !0;
        }
        if (Vs(t)) {
            return !0;
        }
        if (jc(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Fs) {
            return !0;
        }
        if ($u?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (lr(t) || Ba(t) || t === fo || t === co) {
            return !0;
        }
    } else if (t === Zi || t === us || t === ds) {
        return !0;
    }
    return !1;
};

const _u = (t, n) => {
    let e = pl(t) ? kn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (tr(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let bu = !1;

const gu = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (bu = !0);
            const n = `{${tr(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${_u(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = Su(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${gu(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Eu(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = bu ? "" : `(${JSON.stringify(t).length} chars)`;
        bu = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Eu = t => iu[t] || `Unknown(${t})`;

const Su = t => ru[t] || `Unknown(${t})`;

function Wn(t, n, e, s = 0) {
    const o = Vn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Vn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.Pt = t[i + 1]);
        yield;
    }
}

const ku = new WeakMap;

const Ru = /^[A-Za-z0-9+/]*$/;

const Pu = t => {
    const n = t.Ht === void 0;
    t.Ht ??= new Map;
    return n;
};

const Tu = (t, n) => {
    if (n) {
        t.Ht.clear();
        t.Ht = void 0;
    }
};

const Au = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t.k(e);

      case 2:
        const s = t.Zt(e);
        return s === -1 || s === void 0 ? Zi : t.k(s);

      case 14:
        return e;

      case 3:
        return eu[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t.k(i);
                const f = t.k(l);
                n = Fn(u, f, r !== -1 ? s : null, t);
            } else {
                n = Fn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Pc(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return za(null);

      case 30:
        return new $s(t, 0);

      case 31:
        return new Ls(t, null, null, null);

      case 32:
        return new ws(t, null);

      case 33:
        return new Ss(t, null, void 0, {});

      case 34:
        return new Es(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Au(t, s, o);
            const i = Hc(r, 0, t);
            cf(s) && t.Ht.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Ds(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        ku.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !Ru.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw ir(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return y(null);

      case 10:
        return zn(t, e);

      case 11:
        const l = zn(t, e);
        if (pl(l)) {
            Zl(l);
            return mc(l);
        }
        throw ir(17, [ typeof l ]);

      case 39:
        return new Fs({});

      case 42:
        return new Fs({
            j: null,
            rt: !0
        });

      case 43:
        return new Fs({
            j: null,
            rt: !1
        });

      case 40:
      case 44:
        return new fs(null, null, null, null);

      case 41:
        return new su;

      default:
        throw ir(18, [ n ]);
    }
};

function zn(t, n) {
    return n ? t.rootVNode ? ql(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const qu = (t, n, e) => {
    let s = null;
    let o = null;
    if (rr(t)) {
        o = t;
    } else {
        if (!er(t)) {
            throw ir(7, [ t ]);
        }
        s = t;
    }
    return Ma(s, n, null, o, e);
};

const Iu = (t, n, e) => Ma(null, n, t, null, e);

const Mu = (t, n) => Ma(null, t, null, null, n);

const Nu = (t, n, e) => {
    const s = Mu(t, e);
    return s;
};

const xu = (t, n, e, s) => Ma(t, e, null, n, s);

const Cu = (t, n, e, s, o) => {
    const r = xu(t, n, e, o);
    r.De(s);
    return r;
};

const Ou = (t, n, e, s) => {
    const o = qu(t, n, s);
    return o;
};

const ju = (t, n, e, s) => {
    const o = Iu(t, n, s);
    return o;
};

const Lu = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

function Un(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Fu = (t, n, e) => new Ls(null, t, n, e || null);

class Xu {
    We;
    $t;
    $n=null;
    It=!1;
    fn;
    k;
    pn;
    Ve=0;
    Kt=null;
    ze=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.pn = t;
        this.fn = n;
        this.We = sr;
        this.$t = new WeakMap;
        this.k = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return ha(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        if (Ue) {
            return Ud(t, n, e, this.setHostProp.bind(this), this.$t, s);
        }
        throw Error("Serialization context is only available on the server");
    }
    dt() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Du = Symbol();

const Bd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Du] = t;
    return n;
};

class Wu {}

class Vu {}

const zu = t => {
    const n = t.Tt;
    return !!n && (n.vnodeData[0] & 32) !== 0;
};

const Uu = t => {
    t.catch(() => {});
};

function Bn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Qn(n, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    const i = t => {
        Uu(t);
        o.push(t);
        o.push(Promise);
    };
    await (async () => {
        for (;o.length; ) {
            let e = "render";
            try {
                const c = o.pop();
                if (c === Wu) {
                    const s = o.pop();
                    if (__EXPERIMENTAL__.catchBoundary && zu(n)) {
                        continue;
                    }
                    e = "hook";
                    await t(() => o.push(s()));
                    continue;
                }
                if (__EXPERIMENTAL__.catchBoundary && c === Vu) {
                    const t = o.pop();
                    if (zu(n)) {
                        continue;
                    }
                    const e = t.apply(n);
                    hi(e) && await e;
                    continue;
                }
                if (typeof c === "function") {
                    if (c === Promise) {
                        const t = o.pop();
                        if (__EXPERIMENTAL__.catchBoundary && zu(n)) {
                            continue;
                        }
                        o.push(await t);
                    } else {
                        const t = c.apply(n);
                        hi(t) && await t;
                    }
                    continue;
                }
                if (__EXPERIMENTAL__.catchBoundary && zu(n)) {
                    hi(c) && c.catch(() => {});
                    continue;
                }
                Jn(n, r, i, c, s);
            } catch (t) {
                n.handleError(t, n.getOrCreateLastNode(), e);
            } finally {
                const t = n.streamHandler.waitForPendingFlush();
                hi(t) && await t;
            }
        }
    })();
}

function Hn(t, n) {
    t(n);
    __EXPERIMENTAL__.catchBoundary && typeof n === "function" && t(Vu);
}

function Jn(t, n, e, s, o) {
    if (s == null) {
        t.textNode("");
    } else if (typeof s === "boolean") {
        t.textNode("");
    } else if (typeof s === "number") {
        t.textNode(s + "");
    } else if (typeof s === "string") {
        t.textNode(s);
    } else if (typeof s === "object") {
        if (Array.isArray(s)) {
            for (let t = s.length - 1; t >= 0; t--) {
                Hn(n, s[t]);
            }
        } else if (qc(s)) {
            t.openFragment(ts);
            const e = t.getOrCreateLastNode();
            const o = s instanceof Ls ? s.st() : s;
            n(t.closeFragment);
            n(() => ha(o, e, ".", t));
            n(Wu);
        } else if (hi(s)) {
            t.openFragment(ts);
            n(t.closeFragment);
            e(s);
            n(() => t.streamHandler.flush());
        } else if (function r(t) {
            return !!t[Symbol.asyncIterator];
        }(s)) {
            n(async () => {
                if (__EXPERIMENTAL__.catchBoundary && zu(t)) {
                    return;
                }
                const n = () => ({
                    currentStyleScoped: o.currentStyleScoped,
                    parentComponentFrame: o.parentComponentFrame
                });
                try {
                    for await (const e of s) {
                        await Qn(t, e, n());
                        await t.streamHandler.flush();
                    }
                } catch (e) {
                    t.handleError(e, t.getOrCreateLastNode(), "render");
                    await Qn(t, null, n());
                }
            });
        } else {
            const r = s;
            const i = r.type;
            if (typeof i === "string") {
                (function e(t, n) {
                    const e = is(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(r, o.currentStyleScoped);
                let s = null;
                const c = t.openElement(i, r.key, r.varProps, r.constProps, o.currentStyleScoped, s, !!(r.flags & 4));
                c && t.htmlNode(c);
                __EXPERIMENTAL__.catchBoundary && is(r, wr) && n(((t, n) => {
                    const e = t.Tt;
                    t.Tt = n;
                    return () => {
                        t.Tt = e;
                    };
                })(t, t.getOrCreateLastNode()));
                n(t.closeElement);
                if (i === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (i === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.At) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = r.children;
                l != null && Hn(n, l);
            } else if (rr(i)) {
                if ((__EXPERIMENTAL__.pendingBoundary || __EXPERIMENTAL__.catchBoundary) && (t => typeof t === "function" && Du in t)(i)) {
                    n(() => (t => t[Du])(i)(t, r, o, n));
                    return;
                }
                if (i === co) {
                    const e = r.key != null ? {
                        [Xr]: r.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = r.children;
                    s != null && Hn(n, s);
                } else if (i === fo) {
                    const e = o.parentComponentFrame;
                    if (e) {
                        const s = e.componentNode.id || "";
                        const i = {};
                        i[dr] = s;
                        t.openProjection(i);
                        const c = e.componentNode;
                        const l = t.getOrCreateLastNode();
                        const u = R(c, r, t);
                        i[hr] = u;
                        n(Bn(o, o.currentStyleScoped, o.parentComponentFrame));
                        n(t.closeProjection);
                        const f = r.children || null;
                        const a = e.consumeChildrenForSlot(l, u) || f;
                        f && a !== f && t.addUnclaimedProjection(e, "", f);
                        Hn(n, a);
                        n(Bn(o, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = ts;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (i === po) {
                    t.commentNode(is(r, "data") || "");
                } else if (i === yo) {
                    t.streamHandler.flush();
                    const s = r.children;
                    let i;
                    i = rr(s) ? s({
                        async write(n) {
                            await Qn(t, n, {
                                currentStyleScoped: o.currentStyleScoped,
                                parentComponentFrame: o.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : s;
                    hi(i) ? e(i) : n(i);
                } else if (i === ho) {
                    t.htmlNode(is(r, "data"));
                } else if (i === $o) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    Hn(n, r.children);
                } else if (Ba(i)) {
                    const e = {};
                    t.openComponent(e);
                    const s = t.getOrCreateLastNode();
                    n(Bn(o, o.currentStyleScoped, o.parentComponentFrame));
                    n(() => t.closeComponent());
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(r.children, o.currentStyleScoped, o.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Ua];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(cr, o);
                        s.setProp(Dr, r);
                        n.key !== null && s.setProp(Xr, n.key);
                        return Go(t, s, s, o, r);
                    })(t, r, i);
                    if (hi(l)) {
                        Uu(l);
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const r = So(s.getProp(br));
                            n(e);
                            n(Bn(o, r, c));
                        });
                    } else {
                        n(l);
                        const t = So(s.getProp(br));
                        n(Bn(o, t, c));
                    }
                } else {
                    const s = {
                        [Xr]: r.key
                    };
                    t.openFragment(s);
                    n(t.closeFragment);
                    const o = t.getParentComponentFrame();
                    const c = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Go(t, o, n, e, s.props);
                    })(t, o && o.componentNode, i, r);
                    hi(c) ? e(c) : n(c);
                }
            }
        }
    }
}

function Yn(t, n, e, s) {
    if (!__EXPERIMENTAL__.catchBoundary) {
        throw n;
    }
    for (let o = e; o; o = o.parentComponent) {
        const e = te(o);
        if (!e || !e.qt) {
            continue;
        }
        if (t.It && e.Mt) {
            throw n;
        }
        Bf(e, n, s);
        wi(t).Nt = !0;
        t.It && Lf(e);
        Gn(t, o, e);
        return;
    }
    throw n;
}

function Gn(t, n, e) {
    const s = new Map;
    let o = null;
    let r = 0;
    for (let t = n; t; t = t.parentComponent) {
        t.id && s.set(t.id, {
            node: t,
            depth: r++
        });
        if (t !== n && !o) {
            const n = te(t);
            n?.error === void 0 && t.hasSlotProps() || (o = t);
        }
    }
    const i = {
        node: null,
        depth: -1
    };
    const c = n.children;
    if (c) {
        for (let n = 0; n < c.length; n++) {
            ne(t, c[n], s, i);
        }
    }
    if (i.node) {
        const s = i.node.parentComponent;
        if (i.node === n) {
            t.xt(o);
        } else if (s?.id) {
            t.xt(s);
            e.projectedContentOwner = s;
        }
    }
}

function Zn(t, n) {
    Xf(t, "signal");
    if (n.length === 0) {
        return;
    }
    const e = new Set;
    if (__EXPERIMENTAL__.catchBoundary) {
        for (let t = 0; t < n.length; t++) {
            const s = Kn(n[t]);
            s && e.add(s);
        }
    }
    if (e.size === 0) {
        Uf(t) && Ye(t);
        return;
    }
    for (const n of e) {
        Vf(t, n) && Of(n.Ct, t, "signal", n.boundaryId ?? "");
    }
}

function Kn(t) {
    for (let n = t; n; n = n.parentComponent) {
        const t = te(n);
        if (t?.qt) {
            return t;
        }
    }
    return null;
}

function te(t) {
    const n = t.getProp(gr);
    return n ? ci(n, Tf.id, 0) : null;
}

function ne(t, n, e, s) {
    n.vnodeData[0] |= 32;
    const o = n.getProp(dr);
    if (o) {
        const t = e.get(o);
        if (t) {
            t.node.removeProp(n.getProp(hr) ?? "");
            if (t.depth > s.depth) {
                s.node = t.node;
                s.depth = t.depth;
            }
        }
    }
    Pn(t, n);
    const r = n.getProp(Wr);
    if (r) {
        for (let n = 0; n < r.length; n++) {
            const e = r[n];
            Tc(e) && Pn(t, e);
        }
    }
    const i = n.children;
    if (i) {
        for (let n = 0; n < i.length; n++) {
            ne(t, i[n], e, s);
        }
    }
}

const Bu = () => Ra;

const Qu = async t => {
    const [n, e] = Ra;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = xn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Hu = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e) {
        return e;
    }
    const r = Ma(null, "_rsc", Qu, null, [ t, {} ], o.$);
    const i = Ps(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Ju = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (hi(t)) {
        return t.then(n, s);
    }
    const o = Yu(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s) {
        const t = r.error ?? r.Vt;
        if (t) {
            return s(t);
        }
    }
    const i = o ? r.value?.r : r.value;
    return hi(i) ? i.then(n, s) : n(i);
};

const Yu = t => t && t.__brand === "resource";

function ee(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        !n.bt.startsWith("_") && (Array.isArray(n.Ot) || s && n.jt) && (n = Ma(null, "_run", C, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = Ln(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (lr(o)) {
                i(c(o));
                re(t, n, o);
            } else if (o != null) {
                const e = ee(t, n, o, s);
                e && i(e);
            }
        }
    } else if (lr(r)) {
        o = c(r);
        re(t, n, r);
    }
    return o;
}

function re(t, n, e) {
    const s = Ni(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.Lt.add(r);
        t.Ft.add(e);
    }
}

const Gu = (t, n, e) => {
    tf(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Zu = (t, n, e) => {
    tf(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Ku = (t, n, e) => {
    tf(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const tf = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = nf();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + Mi(i), e, s);
            }
        } else {
            r(t + Mi(n), e, s);
        }
    }
};

const nf = () => {
    const t = la();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Qr);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Qr, s);
    }
    let o = t.$.getHostProp(e, Hr);
    o === null && (o = 0);
    t.$.setHostProp(e, Hr, o + 1);
    let r = t.$.getHostProp(e, Jr);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Jr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const ef = function(t, n) {
    const e = Ne(n);
    return na(e, () => {
        typeof this === "string" && Pa(Ta(e, this));
        const s = Ra?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = Ra?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        mn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let rf;

function ie(t) {
    const n = sa();
    if (!n) {
        return;
    }
    rf ||= Iu(ef, "_hmr");
    const e = n._;
    const s = rf.w([ e, t ]);
    Zu("qHmr", s);
}

function se(t, n, e, s, o) {
    const r = dl();
    gl(r, hr, o);
    r.parent = n;
    gl(n, o, r);
    gl(r, cr, e);
    gl(r, Dr, s);
    r.dirty = 4;
    pn(t, r, 1);
    return r;
}

function oe(t, n) {
    gl(t, fr, n);
    t.flags |= 2048;
}

function le(t, n, e) {
    gl(n, Dr, e);
    mn(t, n, 4);
}

function ce(t, n, e, s) {
    gl(n, s, null);
    const o = [];
    kt(t, o, e);
    Ol(o);
    if (e.flags & 2048) {
        const t = bl(e, fr, null);
        t && t.replaceChildren();
        gl(e, fr, null);
        e.flags &= -2049;
    }
}

let sf = Promise.resolve();

const of = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const lf = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !of.has(t));
};

function* ue(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ae(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* fe(t, n, e = Array(n.length / 2)) {
    const s = Pu(t);
    const o = n.length / 2;
    const r = new Uint8Array(o);
    const i = t.k;
    const c = s => {
        if (!r[s]) {
            r[s] = 1;
            const o = s * 2;
            const i = n[o];
            const c = n[o + 1];
            e[s] = i === 0 ? c : Au(t, i, c);
        }
        return e[s];
    };
    t.k = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const r = n[o];
            const i = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            cf(r) && (yield* he(t, c, r, i));
            yield;
        }
    } finally {
        t.k = i;
        Tu(t, s);
    }
    return e;
}

function* ae(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Au(t, n, e);
    cf(n) && (yield* he(t, s, n, e));
    return s;
}

function* he(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* ue(t, s));
    switch (e) {
      case 4:
        yield* ue(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!lf(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = ku.get(t);
            if (e) {
                if (ku.has(o)) {
                    throw ir(37);
                }
                r(o);
            } else {
                i(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                lf(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t._t = e[0];
            t.h = e[1];
            t.Xt = e[2];
            t.ht = e[3];
            break;
        }

      case 29:
        n[Ua][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Dt = e[0];
            t.ft = new Set(e.slice(1));
            pe(t.ft, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.lt = t.getSyncFn(o[0]);
            e.ct = o[1];
            e.Dt = us;
            e.h = o[2];
            e.h |= 1;
            e._ = o[3];
            e.ft = new Set(o.slice(4));
            (function r(t) {
                if (t._ !== null && pl(t._)) {
                    const n = t._;
                    const e = t.ft;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (er(e)) {
                                const o = bl(n, e, null);
                                if (o !== null) {
                                    t.Dt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Gl(n);
                        e && n.firstChild === n.lastChild && ml(e) && (t.Dt = Jl(e));
                    }
                }
            })(e);
            pe(e.ft, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Wt = e[0];
            e[1] && (t.ft = new Set(e[1]));
            e[2] && (t.yt = new Set(e[2]));
            e[3] && (t.wt = new Set(e[3]));
            e[4] && (t.Vt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.zt = !0);
            const o = e.length > 6;
            o && (t.Dt = e[6]);
            t.Dt === us && (t.h |= 1);
            if (e[7] !== void 0 && e[7] !== 1) {
                t.Ut = e[7] ?? 1;
                t.Bt = [];
            }
            t.Qt = e[8] ?? 0;
            pe(t.ft, t);
            pe(t.yt, t);
            pe(t.wt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Wt = r[0];
            const i = o.Wt.resolve(t).catch(() => {});
            sf = sf.finally(() => i);
            r[1] && (o.ft = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Dt = r[2]);
            e !== 34 && o.Dt !== us && (o.h &= -2);
            pe(o.ft, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === Zi) {
                o = new Ds(co, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[Ji] = o;
            const r = t[Yi];
            r.ft = e[3];
            $e(r.ft, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.j = s[0];
            t.data.rt = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            de(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            de(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = Bc(n);
            const o = t.Ht.get(e);
            if (o) {
                t.Ht.delete(e);
                yield* he(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Wc(n);
            c.h = r;
            c.ft = i;
            $e(c.ft, e);
            break;
        }

      default:
        throw ir(16, [ e ]);
    }
}

function de(t) {
    const n = Ue;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[mi] ||= new Map;
    e[mi].set(t.property, t);
}

function pe(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function $e(t, n) {
    if (t) {
        for (const [, e] of t) {
            pe(e, n);
        }
    }
}

const cf = t => t >= 23 || t === 4 || t === 5;

const uf = new WeakMap;

const ff = Symbol();

const af = (t, n) => {
    if (!Array.isArray(n) || pl(n) || (t => tr(t) && ff in t)(n)) {
        return n;
    }
    let e = uf.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new hf(t, n));
        uf.set(n, e);
    }
    return e;
};

class hf {
    $;
    Ue;
    constructor(t, n) {
        this.$ = t;
        this.Ue = n;
    }
    get(t, n, e) {
        if (n === ff) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Ue.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Ue[o];
        const i = this.Ue[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Pu(c);
        try {
            const e = Au(c, r, i);
            Reflect.set(t, n, e);
            this.Ue[o] = 0;
            this.Ue[o + 1] = e;
            cf(r) && ((t, n, e, s) => {
                const o = Pu(t);
                try {
                    const o = he(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    Tu(t, o);
                }
            })(c, e, r, i);
            return e;
        } finally {
            Tu(c, l);
        }
    }
    has(t, n) {
        if (n === ff) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === ff) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Ue.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Ue[i] = 0;
        this.Ue[i + 1] = e;
        return !0;
    }
}

const df = t => {
    if (!t.Be) {
        t.Be = !0;
        t.Qe();
    }
};

const pf = (t, n, e) => {
    const s = {
        He: t,
        Qe: void 0,
        Be: !1
    };
    const o = el(() => {
        ((t, n, e) => {
            t.Be = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.He.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        df(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.Un?.();
            n(t);
        }, t => {
            o.Un?.();
            e(t);
        });
    });
    s.Qe = o;
    return s;
};

async function ye(t) {
    const n = Ud(null, null, () => "", () => {}, new WeakMap);
    n.kt(t);
    await n.Jt();
    return n.Yt.toString();
}

async function we(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = _e(n, () => e);
    s.Gt = e;
    await $f(fe(s, n, e));
    return e[0];
}

const $f = t => new Promise((n, e) => {
    const s = pf(t, n, e);
    df(s);
});

function me(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function ve(t) {
    let n;
    const e = _e(t, () => n);
    n = af(e, t);
    e.Gt = n;
    return e;
}

function _e(t, n) {
    const e = {
        k: t => me(t, n()),
        Zt: t => e.Pt?.[+t],
        getSyncFn: () => () => {},
        $t: new WeakMap,
        element: null,
        Pt: null
    };
    Wn(t, e);
    return e;
}

const yf = (t, n) => {
    const e = new WeakSet;
    return ua(wf, t, e, "_", n);
};

const wf = (t, n, e, s) => {
    const o = Bc(t);
    if (o == null) {
        return t;
    }
    if (vf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (qc(o)) {
            return t;
        }
        if (vu(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (hi(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (nr(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw ir(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw ir(3, [ o ]);
                    }
                    wf(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof xi) {
                return t;
            }
            if (Ke(o)) {
                for (const [t, s] of Object.entries(o)) {
                    wf(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw ir(3, [ i ]);
    }
    return t;
};

const mf = /*#__PURE__*/ new WeakSet;

const vf = t => {
    if (tr(t) || rr(t)) {
        return !mf.has(t) && !(gf in t);
    }
    return !0;
};

const _f = t => !!t && (tr(t) || typeof t === "function") && (mf.has(t) || gf in t);

const bf = t => {
    (tr(t) && t !== null || typeof t === "function") && mf.add(t);
    return t;
};

const gf = Symbol();

const Ef = Symbol();

const Sf = t => /*#__PURE__*/ Object.freeze({
    id: Mi(t)
});

const kf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o._, t, n);
    s(1);
};

const Rf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o._, t);
    if (typeof n === "function") {
        return s(Fe(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw ir(8, [ t.id ]);
};

const Pf = t => {
    const n = oa();
    const e = n._;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const Tf = /*#__PURE__*/ Sf("qk-error");

const Af = (t, n) => {
    try {
        return t();
    } catch {
        return n;
    }
};

const qf = "An error occurred";

const If = t => Ro(Af(() => t instanceof Error ? `${t.name}: ${t.message}\n${t.stack ?? ""}` : t + "", "unknown"));

const Mf = /*#__PURE__*/ Symbol();

const Nf = t => {
    const n = Error(qf);
    n.digest = If(t);
    Object.defineProperty(n, Mf, {
        value: !0
    });
    return n;
};

const xf = t => {
    if (t instanceof Error) {
        return t;
    }
    let n;
    try {
        n = t + "";
    } catch {
        try {
            n = Object.prototype.toString.call(t);
        } catch {
            n = qf;
        }
    }
    const e = Error(n);
    e.cause = t;
    return e;
};

const Cf = (t, n, e) => {
    try {
        if (e) {
            const s = e(t);
            if (s instanceof Error) {
                return (t => Af(() => {
                    t.message;
                    t.name;
                    for (const n in t) {
                        t[n];
                    }
                    return !0;
                }, !1))(s) ? s : Nf(t);
            }
            if (s != null) {
                n && hi(s);
                return Nf(t);
            }
        }
        if (Af(() => t instanceof Error && Mf in t, !1)) {
            return t;
        }
        if (!n) {
            return Nf(t);
        }
        if (t instanceof Error) {
            return t;
        }
        const s = t?.message;
        if (typeof s === "string") {
            const n = Error(s);
            n.cause = t;
            return n;
        }
        return xf(t);
    } catch {
        return Nf(t);
    }
};

const Of = (t, n, e, s) => {
    if (!t) {
        return;
    }
    try {
        const o = If(n);
        Promise.resolve(t(xf(n), {
            phase: e,
            boundaryId: s,
            digest: o
        })).catch(Ye);
    } catch (t) {
        Ye(t);
    }
};

const jf = /*#__PURE__*/ new WeakSet;

const Lf = t => {
    jf.add(t);
};

const Ff = /*#__PURE__*/ Symbol();

const Xf = (t, n) => {
    try {
        Object.defineProperty(t, Ff, {
            value: n,
            configurable: !0
        });
    } catch {}
};

const Df = t => Af(() => t?.[Ff], void 0);

const Wf = /*#__PURE__*/ new WeakMap;

const Vf = (t, n) => {
    if (Df(t) !== "signal") {
        return !0;
    }
    let e = Wf.get(t);
    e || Wf.set(t, e = new WeakSet);
    if (e.has(n)) {
        return !1;
    }
    e.add(n);
    return !0;
};

const zf = /*#__PURE__*/ new WeakSet;

const Uf = t => {
    if (Df(t) !== "signal") {
        return !0;
    }
    if (zf.has(t)) {
        return !1;
    }
    zf.add(t);
    return !0;
};

const Bf = (t, n, e = "render") => {
    t.error = n ?? xf(n);
    const s = t.Ct;
    s && Vf(n, t) && Of(s, n, Df(n) ?? e, t.boundaryId ?? "");
};

const Qf = t => {
    const n = t.detail;
    if (n?.importError) {
        return;
    }
    const e = n.element;
    if (!e || e.ownerDocument !== t.currentTarget) {
        return;
    }
    const s = e.closest(Nr)?.qContainer;
    const o = s?.vNodeLocate(e);
    if (!s || !o) {
        return;
    }
    try {
        s.handleError(n.error, o, "event");
    } catch (t) {
        Ye(t);
    }
};

function be(t, n) {
    const e = t.getHostProp(n, gr);
    return e ? ci(e, Tf.id, 0) : null;
}

const Qd = (t, n = t => t.boundary.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Hd = new WeakMap;

class Jd {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Yd(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Qd(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Yd = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const Gd = () => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return !1;
    }
    const t = sa()?.$;
    return t?.outOfOrderStreaming === !0 && !Vd(t);
};

const Hf = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && Cc(t, n, r);
};

const Jf = new WeakMap;

function* ge(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Kt}"]${$r}`);
    const o = Yf(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(yr) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* Ee(t, e, i.textContent);
        yield;
    }
}

const Yf = t => {
    let n = Jf.get(t);
    if (!n) {
        n = new WeakSet;
        Jf.set(t, n);
    }
    return n;
};

function* Ee(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.tn.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.tn[e * 2 + t] = s[t];
            yield;
        }
        yield* Vn(n.tn, t, e * 2);
        n.nn = af(t, n.tn);
        n.nn.length = n.tn.length / 2;
        n.en = n.Pt;
    }(t, n, s, o);
    Gf(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.pendingBoundary || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t.k(s.rootId);
            const r = s.subscriptions;
            if (o instanceof $s) {
                r instanceof Set && Hf(t, o, o, o.ft ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = Wc(o);
                const e = Vc(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ft ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    Hf(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n.k(i));
}

const Gf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.en ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Pt = e;
};

const Zf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function Se(t, n) {
    const e = t.qVNodeDataState ||= {
        rn: [],
        sn: null
    };
    t.qProcessVNodeDataPatch ||= n => Se(t, Pe(t, n));
    t.qVNodeDataReady = !1;
    e.rn.push(n);
    ke(t, e);
}

function ke(t, n) {
    if (n.sn) {
        return;
    }
    const e = n.rn.shift();
    if (!e) {
        Re(t);
        return;
    }
    n.sn = pf(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.sn = null;
            ke(t, n);
        }
    }, e => {
        n.sn = null;
        Ye(e);
        Re(t);
    });
    df(n.sn);
}

function Re(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* Pe(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* Te(t, s || void 0, e, o, n.textContent));
}

function* Te(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const m = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.pendingBoundary && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* m(s));
            yield;
        }
    };
    const _ = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.pendingBoundary && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const b = t => {
        for (;t && (t = t.nextSibling) && _(t) === 0; ) {}
        return t;
    };
    const v = t => {
        let n = null;
        for (;t && !(n = b(t)); ) {
            t = t.parentNode;
        }
        return n;
    };
    const g = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.pendingBoundary && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let m = 0;
        let E = -1;
        let k = null;
        const R = () => {
            let t = 0;
            for (;Kf(m = r.charCodeAt(y)); ) {
                t += 1 << m - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            k = null;
            const P = s == e ? 2 : _(s);
            if (P === 3) {
                const t = s;
                k = v(s);
                yield* g(n, t, s, k, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (P === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (_(t) !== 65);
            } else if (P === 64) {
                k = s;
                let t;
                do {
                    k = n.nextNode();
                    if (!k) {
                        throw Error("Ignore block not closed!");
                    }
                    t = _(k);
                } while (t !== 32 && t !== 65);
                k = null;
            } else if (P === 9) {
                k = s;
                do {
                    k = b(k);
                    if (!k) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (_(k) !== 8);
                yield* g(n, s, s, k, "", null, c);
            } else if (P === 6) {
                k = b(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* g(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((P & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += R();
                        if (m === 126) {
                            E = p;
                            y++;
                            m = y < f ? r.charCodeAt(w) : 33;
                        }
                        w = ta(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.pendingBoundary && !u && P === 130 ? $.call(s, a) : null;
                if (h === p) {
                    E !== h || u && s === e || i.set(u ? ki(l, h) : h, s);
                    const t = r.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== Si || n.charCodeAt(1) !== Si || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        P !== 3 && d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.pendingBoundary && t !== null) {
                    yield* S(c, s, t);
                    k = b(s);
                    k && (n.currentNode = k);
                }
            }
            yield;
        } while (s = k || n.nextNode());
    };
    const E = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* g(r, e, e, v(e), s, n.qVNodeRefs, n, o);
    };
    const S = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* E(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.pendingBoundary && n !== void 0 ? yield* S(e, s, n, o) : yield* E(e, s, o);
        return;
    }
    yield* m(t);
    const k = t.createTreeWalker(t, 129);
    yield* g(k, null, k.firstChild(), null, "", null, null);
}

const Kf = t => 33 <= t && t <= 46;

const ta = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Kf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Ae(t) {
    return t.ln === 3;
}

function qe(t, n) {
    const e = t.cn ||= {
        rn: [],
        sn: null
    };
    t.ln = 2;
    e.rn.push(n);
    Ie(t, e);
}

const na = (t, n) => {
    const e = t;
    if (Ae(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!Ae(e)) {
                    (e.un ||= []).push(s);
                    return;
                }
                Zf(e.document, () => {
                    Ae(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function Ie(t, n) {
    if (n.sn) {
        return;
    }
    const e = n.rn.shift();
    if (!e) {
        Me(t);
        return;
    }
    n.sn = pf(e, () => {
        n.sn = null;
        Ie(t, n);
    }, e => {
        n.sn = null;
        Ye(e);
        Me(t);
    });
    df(n.sn);
}

function Me(t) {
    const n = t.ln;
    if (n !== 2) {
        return;
    }
    t.ln = 3;
    t.cn = void 0;
    const e = t.un;
    t.un = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Ne(t) {
    const n = Ce(t);
    if (!n) {
        throw ir(24);
    }
    return xe(n);
}

function xe(t) {
    const n = t;
    return n.qContainer ||= new ea(n);
}

function Ce(t) {
    return t.closest(Nr);
}

function Oe(t, n) {
    const e = t + "";
    const s = n?.closest(Nr);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.pendingBoundary || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            Se(t, function* i(t, n, e, s, o, r) {
                yield* Te(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* Pe(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        Zf(t, () => {
            o.element.qContainer === o && qe(o, ge(o, e));
        });
    }
}

class ea extends Xu {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    $t=new WeakMap;
    Je;
    Kt;
    Pt=null;
    vNodeLocate=t => ql(this.rootVNode, t);
    ln=0;
    un=void 0;
    cn=void 0;
    tn;
    nn;
    en=null;
    Ye=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(qr);
        if (!this.qContainer) {
            throw ir(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.ze = t.getAttribute(kr);
        this.Kt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = al(this.element);
        this.tn = [];
        this.nn = [];
        __EXPERIMENTAL__.pendingBoundary && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= Oe);
        this.Je = Sr(n, this.Kt) || Ki;
        this.Ge();
        t.qContainer = this;
        t.qDestroy = () => this.Un();
        __EXPERIMENTAL__.catchBoundary && function e(t) {
            if (!t.qErrorHandler) {
                t.qErrorHandler = Qf;
                t.addEventListener?.("qerror", Qf);
            }
        }(this.document);
        this.ln = 1;
        (function s(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            Se(e, function* s(t) {
                yield* Te(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        Zf(n, () => {
            this.ln === 1 && qe(this, this.Ze());
        });
    }
    * Ze() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Kt}"]:not(${$r})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${$r})`);
        if (n) {
            this.tn = JSON.parse(n.textContent);
            yield* Vn(this.tn, this);
            this.en = this.Pt;
            const e = this.tn.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.nn = s !== null && e > 0 && e >= +s ? yield* fe(this, this.tn) : af(this, this.tn);
        }
        __EXPERIMENTAL__.pendingBoundary && (yield* ge(this));
        this.Ke();
        t.setAttribute(qr, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    Un() {
        this.vNodeLocate = () => null;
        this.tn.length = 0;
        this.nn.length = 0;
        this.k = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.pendingBoundary && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(qr);
        const n = t.ownerDocument;
        this.cn = void 0;
        this.ln = 0;
        const e = n.querySelector(Nr) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.pendingBoundary && (e || (n.qProcessOOOS = void 0));
    }
    Ke() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(_r);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Hn(t, n) {
        this.nn[t] = n;
    }
    parseQRL(t) {
        return Xn(t, this);
    }
    handleError(t, n, e = "render") {
        if (!__EXPERIMENTAL__.catchBoundary) {
            const e = n && this.resolveContext(n, Tf);
            if (!e) {
                Ge(t);
                return;
            }
            e.error = t;
            return;
        }
        const s = t ?? xf(t);
        let o = n;
        for (;o; ) {
            const n = this.resolveContextHost(o, Tf);
            if (!n) {
                break;
            }
            const r = be(this, n);
            if (r && r.error === void 0) {
                r.error = s;
                Vf(t, r) && this.tr(n, r, t, Df(t) ?? e);
                mn(this, n, 4);
                return;
            }
            if (n.dirty & 4) {
                Ye(t);
                return;
            }
            o = this.getParentHost(n);
        }
        Ge(t);
    }
    zn(t, n) {
        Xf(t, "signal");
        if (n.length === 0) {
            return;
        }
        const e = new Set;
        if (__EXPERIMENTAL__.catchBoundary) {
            for (let t = 0; t < n.length; t++) {
                const s = this.resolveContextHost(n[t], Tf);
                s && e.add(s);
            }
        }
        if (e.size === 0) {
            Uf(t) && Ye(t);
            return;
        }
        for (const n of e) {
            const e = be(this, n);
            e && Vf(t, e) && this.tr(n, e, t, "signal");
        }
    }
    tr(t, n, e, s) {
        const o = this.getHostProp(t, Dr);
        Of(o?.onError$, e, s, n.boundaryId ?? "");
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, gr);
        s == null && this.setHostProp(t, gr, s = []);
        li(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        const e = this.resolveContextHost(t, n);
        return e ? ci(this.getHostProp(e, gr), n.id, 0) : void 0;
    }
    resolveContextHost(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, gr);
            if (e != null && ui(e, n.id, 0)) {
                return t;
            }
            t = this.getParentHost(t);
        }
        return null;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (vl(n)) {
                if (bl(n, cr, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        gl(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Wr:
          case Dr:
          case cr:
          case gr:
          case Er:
            s = this.k;
            break;

          case Vr:
          case Hr:
            s = parseInt;
            break;
        }
        return bl(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    k=t => me(t, this.nn);
    Zt(t) {
        return this.en?.[t];
    }
    getSyncFn(t) {
        const n = this.Je[t];
        return n;
    }
    nr(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, br);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, br, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ye == null) {
            this.Ye = new Set;
            const t = this.document.querySelectorAll(vr);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ye.add(e.getAttribute(mr));
            }
        }
        if (!this.Ye.has(n)) {
            this.Ye.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(mr, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Ge() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === Zr) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.pn = {
            containerAttributes: t
        };
    }
}

let ra;

let Zd;

if (Ue) {
    const t = He();
    t && (Zd = new t);
}

function je(t) {
    if (Zd) {
        const t = Zd.getStore();
        if (t) {
            return t;
        }
    }
    if (ra === void 0) {
        const n = sa();
        if (n && n.fn) {
            return n.fn;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return ra;
}

function Le(t, n) {
    if (Zd) {
        return Zd.run(t, n);
    }
    const e = ra;
    const s = () => {
        ra = e;
    };
    ra = t;
    return di(n, t => {
        s();
        return t;
    }, t => {
        s();
        throw t;
    });
}

let ia;

const sa = () => ia;

const oa = () => {
    const t = sa();
    if (!t) {
        throw ir(9);
    }
    return t;
};

const la = () => {
    const t = sa();
    if (!t || t.an !== jr) {
        throw ir(10);
    }
    return t;
};

function Fe(t, n, ...e) {
    return Xe.call(this, t, n, e);
}

function Xe(t, n, e) {
    const s = ia;
    try {
        ia = t;
        return n.apply(this, e);
    } finally {
        ia = s;
    }
}

const ca = (t, n, e = Ne(n)) => {
    const s = ql(e.rootVNode, n);
    const o = e.fn;
    o && function r(t) {
        if (Zd) {
            Zd.enterWith(t);
            return;
        }
        ra = t;
    }(o);
    const i = We(o, s, t);
    i.$ = e;
    return i;
};

function De(t, n, e) {
    const s = {
        _: n,
        an: jr,
        hn: void 0,
        fn: t,
        $: e,
        dn: void 0
    };
    return s;
}

function We(t, n, e) {
    const s = {
        _: n,
        an: e,
        hn: void 0,
        fn: t,
        $: void 0
    };
    return s;
}

const ua = (t, ...n) => {
    if (typeof t === "function") {
        if (!ia) {
            return t(...n);
        }
        {
            const e = ia.hn;
            try {
                ia.hn = void 0;
                return t(...n);
            } finally {
                ia.hn = e;
            }
        }
    }
    if (qc(t)) {
        return t.untrackedValue;
    }
    return Bc(t);
};

const fa = /*#__PURE__*/ De(void 0, void 0, void 0);

const aa = (t, n, e, s, o) => {
    const r = fa.hn;
    const i = fa.$;
    try {
        fa.hn = w(n, e, o);
        fa.$ = s;
        return Xe(fa, t);
    } finally {
        fa.hn = r;
        fa.$ = i;
    }
};

const ha = (t, n, e, s, o) => {
    t instanceof Ls && t._ !== n && n && (t._ = n);
    return aa(() => t.value, n, e, s, o);
};

const da = () => sa()?._;

const pa = () => {
    const t = sa();
    if (t) {
        return t.an;
    }
};

const $a = () => {
    const t = sa();
    if (t) {
        return t.$;
    }
};

const ya = t => t;

const wa = t => t.l || Promise.resolve();

let ma;

class va {
    gt;
    bt;
    er;
    rr;
    $;
    constructor(t, n, e, s, o) {
        this.gt = t;
        this.bt = n;
        this.er = e;
        this.rr = s;
        s && this.ir(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        Be && t && ze(t, .8);
    }
    get ot() {
        return Xd(this.bt);
    }
    ir(t) {
        this.rr = t;
        hi(t) && t.then(t => this.rr = t, t => {
            const n = `qrl ${this.bt} failed to load`;
            if (Ue) {
                console.error(n, t);
            } else if (Be) {
                const e = this.gt === null ? "symbol:" + this.bt : "chunk:" + this.gt;
                const s = this.$;
                let o = s && ma?.get(s);
                if (!o?.has(e)) {
                    if (s) {
                        if (!o) {
                            o = new Set;
                            (ma ||= new WeakMap).set(s, o);
                        }
                        o.add(e);
                    }
                    console.error(n, t);
                }
            }
            this.rr = null;
        });
    }
    sr() {
        if (this.rr != null) {
            return this.rr;
        }
        if (this.gt === "") {
            const t = this.$.Kt;
            const n = this.$.element?.ownerDocument || document;
            const e = Sr(n, t);
            return this.rr = e[+this.bt];
        }
        Be && this.gt && ze(this.gt, 1);
        const t = this.bt;
        const n = this.er ? this.er().then(n => n[t]) : si().importSymbol(this.$?.element, this.gt, t);
        this.ir(n);
        return this.rr;
    }
}

const _a = Symbol();

const ba = t => t?.[_a] ?? t;

class ga {
    lr;
    resolved=void 0;
    Ot;
    $;
    constructor(t, n, e) {
        this.lr = t;
        if (n) {
            this.Ot = n;
            typeof n === "string" && (this.$ = e);
        }
        t.rr == null || this.Ot && typeof this.Ot === "string" || hi(t.rr) || (this.resolved = qa(this, t.rr));
    }
}

const Ea = function(t, ...n) {
    const e = ba(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = sa();
    return Sa.call(e, s?.$).then(() => Xe.call(t, s, e.resolved, n));
};

const Sa = async function(t) {
    const n = ba(this);
    return pi(Ia(n, t), () => n.resolved);
};

const ka = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[_a].resolved;
        },
        set(t) {
            this[_a].resolved = t;
        }
    },
    Ot: {
        get() {
            return this[_a].Ot;
        },
        set(t) {
            this[_a].Ot = t;
        }
    },
    jt: {
        get() {
            return this[_a].lr.jt;
        }
    },
    $: {
        get() {
            return this[_a].$;
        },
        set(t) {
            this[_a].$ = t;
        }
    },
    lr: {
        get() {
            return this[_a].lr;
        }
    },
    gt: {
        get() {
            return this[_a].lr.gt;
        }
    },
    bt: {
        get() {
            return this[_a].lr.bt;
        }
    },
    ot: {
        get() {
            return this[_a].lr.ot;
        }
    },
    dev: {
        get() {
            return this[_a].lr.dev;
        }
    },
    cr: {
        value: Ea
    },
    w: {
        value: function(t) {
            const n = ba(this);
            const e = new ga(n.lr, t, n.Ot ? n.$ : void 0);
            return Na(e);
        }
    },
    m: {
        value: function() {
            this[_a].lr.jt = !0;
            return this;
        }
    },
    s: {
        value: function(t) {
            const n = ba(this);
            n.lr.ir(t);
            n.resolved = qa(n, t);
        }
    },
    resolve: {
        value: Sa
    },
    getSymbol: {
        value: function() {
            return ba(this).lr.bt;
        }
    },
    getHash: {
        value: function() {
            return ba(this).lr.ot;
        }
    },
    getCaptured: {
        value: function() {
            const t = ba(this);
            Aa(t);
            return t.Ot;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = ba(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Sa.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return Xe(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Ra = null;

const Pa = t => {
    Ra = t;
};

const Ta = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t.k(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const Aa = t => {
    const n = t.Ot;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw ir(13);
        }
        const s = sf;
        Ra = t.Ot = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return Ta(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return Ta(t, n, s + 1, o);
        })(e, n);
        if (sf !== s) {
            return sf;
        }
    } else {
        Ra = n || null;
    }
};

const qa = (t, n) => {
    if (typeof n !== "function" || !t.Ot) {
        return n;
    }
    return function e(...s) {
        Aa(t);
        return n.apply(this, s);
    };
};

const Ia = (t, n) => {
    const e = t.lr;
    const s = typeof t.Ot === "string";
    s && !t.$ && (t.$ = n || sa()?.$);
    if (t.resolved) {
        return;
    }
    const o = ja();
    const r = sa();
    const i = e.sr();
    const c = pi(i, n => {
        t.resolved = qa(t, n);
    });
    if (c) {
        const t = e.bt;
        Ca(t, r?._ instanceof Oi ? r?._.node : void 0, o);
    }
    const l = s && t.$ && Aa(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Ma = (t, n, e, s, o, r) => {
    const i = ((t, n, e, s, o) => new va(t, n, e, s, o))(t, n, s, e, r);
    const c = new ga(i, o, r);
    return Na(c);
};

const Na = t => {
    const n = async function(...t) {
        return Ea.call(n, this, ...t);
    };
    n[_a] = t;
    Object.setPrototypeOf(n, ka);
    return n;
};

const xa = /*#__PURE__*/ new Set;

const Ca = (t, n, e) => {
    if (!xa.has(t)) {
        xa.add(t);
        Oa("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const Oa = (t, n) => {
    Wd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const ja = () => {
    if (Wd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let La = 0;

const Fa = t => Ma(null, "s" + La++, t, null, null);

const Xa = Fa;

const Da = t => t;

const Wa = t => Ma("", or, t, null, null);

const Va = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return Ma("", or, t, null, null);
};

const za = t => {
    function n(n, e, s = 0) {
        const o = t.ot.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Ua] = [ t ];
        return to(i, n, null, n.children, s, r);
    }
    n[Ua] = [ t ];
    return n;
};

const Ua = Symbol();

const Ba = t => typeof t == "function" && t[Ua] !== void 0;

const Qa = t => za(Xa(t));

const Ha = gs(Da);

const Ja = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Ya = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !fi(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(qr, "resumed");
    const s = Ne(t);
    s.pn = e.serverData || {};
    const o = s.rootVNode;
    gl(o, Wi, n);
    mn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            kt(s, [], s.rootVNode);
        }
    };
};

const Ga = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e != null) {
        return e;
    }
    const r = rr(t) ? Fe(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = Hc(r, i, t);
        s(c);
        return c;
    }
};

const Za = t => {
    const n = wi(t);
    return (t => t.toString(36))(n.Ve++);
};

const Ka = () => {
    const {val: t, set: n, iCtx: e} = Wo();
    if (t != null) {
        return t;
    }
    const s = e.$.ze || "";
    const o = s ? Ro(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e._, cr);
    const i = r?.getHash().substring(0, 3) || "";
    const c = Za(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function Ve(t, n) {
    const e = sa();
    return e?.$?.pn[t] ?? n;
}

const th = /*#__PURE__*/ new Map;

const nh = (t, n) => {
    let e = th.get(n);
    e || th.set(n, e = eh(t, n));
    return e;
};

const eh = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = lh;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Wh) {
            r++;
            e = Lh;
        }
        const s = Yh[c];
        for (let p = 0; p < s.length; p++) {
            const $ = s[p];
            const [y, w, m] = $;
            if ((y === l || y === wh || y === mh && rh(l) || y === _h && oh(l)) && (w === e || w === wh || w === mh && rh(e) || w === vh && !rh(e) && e !== Mh || w === _h && oh(e))) {
                const s = r;
                if ($.length == 3 || a($)) {
                    if (c === ph && m === uh && !h()) {
                        r = s;
                        continue;
                    }
                    $.length > 3 && (e = t.charCodeAt(r - 1));
                    if (m === $h || m == yh) {
                        if (m === yh) {
                            if (c !== ch || d()) {
                                if (!ih(e)) {
                                    const t = w == vh ? 1 : w == Ah ? 2 : 0;
                                    f(r - t);
                                }
                            } else {
                                ih(e) ? u(r - 2) : f(r - 2);
                                i++;
                            }
                        }
                        if (w === vh) {
                            r--;
                            e = l;
                        }
                        do {
                            c = o.pop() || lh;
                            if (c === uh) {
                                u(r - 1);
                                i++;
                            }
                        } while (sh(c));
                    } else {
                        o.push(c);
                        if (c === uh && m === lh) {
                            u(r - 8);
                            i = r;
                        } else {
                            m === fh && f(n);
                        }
                        c = m;
                    }
                    break;
                }
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === uh || d()) {
            return;
        }
        u(t);
        s.push(".", ar, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Ih) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Ih) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | zh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        let n = r;
        let s = 0;
        let o = 0;
        let i = 0;
        for (;n < e; ) {
            const e = t.charCodeAt(n++);
            if (i) {
                e === Wh ? n++ : e === i && (i = 0);
            } else if (e === Ph || e === kh) {
                i = e;
            } else if (e === Nh && t.charCodeAt(n) === qh) {
                n = t.indexOf("*/", n + 1);
                if (n === -1) {
                    return !1;
                }
                n += 2;
            } else if (e === Th) {
                s++;
            } else if (e === Ah) {
                s--;
            } else if (e === Xh) {
                o++;
            } else if (e === Dh) {
                o--;
            } else if (s === 0 && o === 0) {
                if (e === Qh) {
                    return !0;
                }
                if (e === jh || e === Hh) {
                    return !1;
                }
            }
        }
        return !1;
    }
    function d() {
        return o.indexOf(uh) !== -1 || o.indexOf(ah) !== -1;
    }
};

const rh = t => t >= xh && t <= Ch || t >= Lh && t <= Fh || t >= Uh && t <= Bh || t >= 128 || t === Vh || t === Ih;

const ih = t => t === Oh || t === Mh || t === Xh || t === Rh || rh(t);

const sh = t => t === hh || t === ah || t === dh || t === uh;

const oh = t => t === Sh || t === bh || t === gh || t === Eh;

const lh = 0;

const ch = 2;

const uh = 5;

const fh = 6;

const ah = 10;

const hh = 11;

const dh = 12;

const ph = 13;

const $h = 17;

const yh = 18;

const wh = 0;

const mh = 1;

const vh = 2;

const _h = 3;

const bh = 9;

const gh = 10;

const Eh = 13;

const Sh = 32;

const kh = 34;

const Rh = 35;

const Ph = 39;

const Th = 40;

const Ah = 41;

const qh = 42;

const Ih = 45;

const Mh = 46;

const Nh = 47;

const xh = 48;

const Ch = 57;

const Oh = 58;

const jh = 59;

const Lh = 65;

const Fh = 90;

const Xh = 91;

const Dh = 93;

const Wh = 92;

const Vh = 95;

const zh = 32;

const Uh = 97;

const Bh = 122;

const Qh = 123;

const Hh = 125;

const Jh = /*@__PURE__*/ (() => [ [ wh, Ph, 14 ], [ wh, kh, 15 ], [ wh, Nh, 16, "*" ] ])();

const Yh = /*@__PURE__*/ (() => [ [ [ wh, qh, ch ], [ wh, Xh, 7 ], [ wh, Oh, fh, ":", "before", "after", "first-letter", "first-line" ], [ wh, Oh, uh, "global" ], [ wh, Oh, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ wh, Oh, 4 ], [ wh, mh, 1 ], [ wh, Mh, 1 ], [ wh, Rh, 1 ], [ wh, 64, ah, "keyframe" ], [ wh, 64, hh, "media", "supports", "container" ], [ wh, 64, dh ], [ wh, Qh, ph ], [ Nh, qh, 16 ], [ wh, jh, $h ], [ wh, Hh, $h ], [ wh, Ah, $h ], ...Jh ], [ [ wh, vh, yh ] ], [ [ wh, vh, yh ] ], [ [ wh, Th, lh ], [ wh, vh, yh ] ], [ [ wh, Th, 8 ], [ wh, vh, yh ] ], [ [ wh, Th, lh ], [ wh, vh, $h ] ], [ [ wh, vh, $h ] ], [ [ wh, Dh, yh ], [ wh, Ph, 14 ], [ wh, kh, 15 ] ], [ [ wh, Ah, $h ], ...Jh ], [ [ wh, Hh, $h ], ...Jh ], [ [ wh, Hh, $h ], [ _h, mh, 1 ], [ wh, Oh, uh, "global" ], [ wh, Qh, ph ], ...Jh ], [ [ wh, Qh, lh ], [ wh, jh, $h ], ...Jh ], [ [ wh, jh, $h ], [ wh, Qh, 9 ], ...Jh ], [ [ wh, Hh, $h ], [ wh, Qh, ph ], [ wh, Oh, uh, "global" ], [ wh, Th, 8 ], ...Jh ], [ [ wh, Ph, $h ] ], [ [ wh, kh, $h ] ], [ [ qh, Nh, $h ] ] ])();

const Gh = t => ({
    styleId: nd(t, t => t, !1)
});

const Zh = /*#__PURE__*/ gs(Gh);

const Kh = t => ({
    scopeId: ar + nd(t, nh, !0)
});

const td = /*#__PURE__*/ gs(Kh);

const nd = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Wo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${Ro(t.ot)}-${n}`)(t, i);
    const l = r._;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.nr(n(t, c), c, l, e));
    }
    r.$.nr(n(t.resolved, c), c, l, e);
    return c;
};

const ed = (t, n) => {
    t.resolve();
    return Rs(t, n);
};

const rd = (t, n) => Uo(ed, t, n);

const id = gs(rd);

const sd = t => {
    t.resolve();
    return Ts(t);
};

const od = t => Uo(sd, t);

const ld = gs(od);

const cd = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Wo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Wd()) {
            e.h |= 32;
            ud(e, i);
        }
        return;
    }
    let c;
    if (Wd() || i === "intersection-observer") {
        c = 1;
        Wd() || t.resolve();
    } else {
        c = 5;
        t.resolve();
        mn(r.$, r._, 1);
    }
    const l = new Pc(c, o, r._, t, null);
    s(l);
    ud(l, i);
};

const ud = (t, n) => {
    n === "intersection-observer" ? Gu("qvisible", fd(t)) : n === "document-ready" ? Zu("qinit", fd(t)) : n === "document-idle" && Zu("qidle", fd(t));
};

const fd = t => Ma(null, "_task", Mn, null, [ t ]);

const ad = gs(Hu);

const hd = /*#__PURE__*/ gs(kc);

const dd = /*#__PURE__*/ gs(cd);

const pd = () => Object.defineProperty({
    error: void 0
}, "error", {
    enumerable: !1
});

async function Kd(t, n, e, s) {
    const o = n + "";
    const r = await e.container.S(o, e);
    t.write(`<template ${yr}="${n}"${s?.attrs ?? ""}>`);
    t.write(r.html);
    t.write("</template>");
    t.emitOutOfOrderSegmentScripts(r.scripts);
    t.emitOutOfOrderExecutorIfNeeded();
    t.emitInlineScript(`qO(${n})`);
    const i = e.container.P;
    if (__EXPERIMENTAL__.catchBoundary && i?.length) {
        t.emitErrorSwapExecutorIfNeeded();
        for (let n = 0; n < i.length; n++) {
            t.emitInlineScript(`qErr(${i[n]})`);
        }
    }
    await t.streamHandler.flush();
}

const $d = () => {
    const [t] = Ra;
    const n = sa()?.$;
    const e = Be;
    e && t && n && function s(t, n) {
        const e = t.resolveContextHost(n, Tf);
        if (!e) {
            return;
        }
        const s = be(t, e);
        if (!s) {
            return;
        }
        (function o(t, n, e) {
            let s = n;
            let o = null;
            let r = wc(n);
            let i = !1;
            for (;r; ) {
                if (vl(r)) {
                    if (bl(r, hr, null) !== null) {
                        i = !0;
                    } else if (bl(r, cr, null) !== null) {
                        if (!i) {
                            const n = be(t, r);
                            if (!n || n.error !== void 0) {
                                o && (s = o);
                                o = r;
                                if (n?.error !== void 0 || !k(r.props)) {
                                    break;
                                }
                            }
                        }
                        i = !1;
                    }
                }
                r = wc(r);
            }
            if (e && e !== o) {
                s = o ?? s;
                o = e;
            }
            if (o) {
                s.key = `${s.key ?? ""}${yd}`;
                mn(t, o, 4);
            } else {
                mn(t, n, 4);
            }
        })(t, e, s.projectedContentOwner ?? null);
        s.error = void 0;
    }(n, t);
};

const yd = "\0";

const wd = t => {
    if (!__EXPERIMENTAL__.catchBoundary) {
        throw Error('<Catch> requires the `catchBoundary` experimental feature. Enable it in your Qwik Vite config: qwikVite({ experimental: ["catchBoundary"] }).');
    }
    const n = (() => {
        const t = Ga(pd);
        kf(Tf, t);
        return t;
    })();
    const e = sa();
    const s = e?.$;
    s && (Vc(n) ?? n).boundaryId === void 0 && (n.boundaryId = Za(s));
    const o = !Be;
    if (!o && n.error === void 0) {
        return /* @__PURE__ */ Ks(fo, null, null, null, 0, null);
    }
    const r = /*#__PURE__*/ Iu($d, "_caR", [ e?._ ]);
    if (o) {
        const e = t.fallback$;
        n.qt = bf(t => e(t, r));
        const o = t.onError$;
        o && (n.Ct = bf((t, n) => o(t, n)));
        return ((t, n) => {
            const e = n?.nextOutOfOrderId(!1) ?? 0;
            return [ 
            /*#__PURE__*/ Ks("div", {
                [wr]: e + "",
                style: "display:contents"
            }, null, 
            /*#__PURE__*/ Ks(fo, null, null, null, 0, null), 1, null), 
            /*#__PURE__*/ Ks(ep, {
                boundaryId: e,
                store: t
            }, null, null, 1, null) ];
        })(n, s);
    }
    const i = Cf(n.error, !0);
    return /* @__PURE__ */ Ks(co, null, null, ((t, n, e) => t(n, e).catch(n => {
        if (t.resolved !== void 0) {
            throw n;
        }
        return /* @__PURE__ */ Ks("div", {
            role: "alert"
        }, null, "Something went wrong.", 0, null);
    }))(t.fallback$, i, r), 0, null);
};

const md = /*#__PURE__*/ za(
/*#__PURE__*/ Iu(wd, "_caC"));

const tp = (t, n) => {
    const e = n.qt;
    delete n.qt;
    const s = Cf(n.error, Qe, t.A);
    return e(s);
};

const np = __EXPERIMENTAL__.catchBoundary ? /*#__PURE__*/ Bd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    if (n.varProps.deliverLate) {
        const n = async n => {
            if (!r.qt) {
                return;
            }
            r.error !== n && Bf(r, n, "render");
            const s = await t.segment("" + o, tp(t, r), e);
            s.container.I(o);
            await t.C(() => Kd(t, o, s, null));
        };
        r.Mt = bf(n);
        t.write(`<template ${yr}="${o}"></template>`);
        if (r.error !== void 0) {
            return n(r.error);
        }
        return;
    }
    if (r.error === void 0 || !r.qt) {
        return;
    }
    Vd(t) ? t.I(o) : s(() => {
        t.emitErrorSwapExecutorIfNeeded();
        t.emitInlineScript(`qErr(${o})`);
    });
    s(tp(t, r));
}) : null;

const ep = __EXPERIMENTAL__.catchBoundary ? /*#__PURE__*/ Bd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    const i = __EXPERIMENTAL__.pendingBoundary && t.outOfOrderStreaming && !Vd(t) && (r.error === void 0 || (t => jf.has(t))(r));
    s(
    /*#__PURE__*/ Ks("div", {
        [i ? Dd : "q:cf"]: o + "",
        style: "display:none"
    }, null, 
    /*#__PURE__*/ Ks(np, {
        boundaryId: o,
        store: r,
        deliverLate: i
    }, null, null, 1, null), 1, null));
}) : null;

const vd = async ({track: t}) => {
    const n = Ra[0];
    t(() => n.items);
    const e = sa();
    const s = e._;
    const o = e.$;
    const r = mn(o, s, 256);
    const i = Ue;
    i && await r;
};

const _d = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    kc(/*#__PURE__*/ Iu(vd, "_eaT", [ t ]));
    return ao;
};

const bd = /*#__PURE__*/ za(
/*#__PURE__*/ Iu(_d, "_eaC"));

const gd = (t, n, e) => lr(t) ? t.getFn(n)(e) : t(e);

const Ed = ({track: t}) => {
    const n = Ra[0];
    const e = sa();
    const s = e._;
    const o = e.$;
    const r = Ue;
    return pi(t(() => gd(n.when$, sa(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return pi(i ? gd(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Bt(s, n);
            mn(o, s, 2);
        });
    });
};

const Sd = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    kc(/*#__PURE__*/ Iu(Ed, "_shT", [ t ]));
    return ao;
};

const kd = /*#__PURE__*/ za(
/*#__PURE__*/ Iu(Sd, "_shC"));

const Rd = /*#__PURE__*/ Sf("qk-reveal");

const Pd = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: As(0)
});

const Td = () => {
    const t = Ra[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!Be) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Qd(t);
};

const Ad = ({cleanup: t}) => {
    const n = Ra[0];
    t(() => {
        if (!Be) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const qd = t => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
    }
    const n = Uo(Pd, t);
    kf(Rd, n);
    const e = !Be;
    if (__EXPERIMENTAL__.pendingBoundary && e && Gd()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                const e = sa().$;
                const s = (Hd.get(e) || 0) + 1;
                Hd.set(e, s);
                return new Jd(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = bf(e);
            return e;
        })(n);
        return /* @__PURE__ */ Ks(sp, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    return /* @__PURE__ */ Ks(fo, null, null, null, 0, "u7_0");
};

const Id = /*#__PURE__*/ za(
/*#__PURE__*/ Iu(qd, "_reC"));

const sp = __EXPERIMENTAL__.pendingBoundary ? /*#__PURE__*/ Bd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ Ks(fo, null, null, null, 0, "u7_0"));
}) : null;

const Md = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback$ == null || !e.value && s.reveal.collapsed ? "none" : "contents"
});

const op = '{display:p1.value==="fallback"&&p0.fallback$!=null&&(p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Nd = (t, n) => ({
    display: t.value === "content" && n.value ? "contents" : "none"
});

const xd = ({track: t, cleanup: n}) => {
    const e = Ra[0], s = Ra[1], o = Ra[2], r = Ra[3];
    const i = t(e);
    const c = Be;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Cd = t => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        throw Error('Pending is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
    }
    const n = zo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.pendingBoundary) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
        }
        return zo(0);
    })();
    const s = (t => {
        const n = Rf(Rd, null);
        const e = Uo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && kc(/*#__PURE__*/ Iu(Ad, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = rd(
    /*#__PURE__*/ Iu(Td, "_reR", [ s ]));
    kc(
    /*#__PURE__*/ Iu(xd, "_peT", [ e, t, n, s ]));
    const r = !Be;
    const i = r && Gd();
    const c = i ? (() => sa().$.nextOutOfOrderId())() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && ua(() => t.fallback$ != null) && (l === null || l.showFallback);
    const f = u && function a(t) {
        return typeof t === "number" && Number.isFinite(t) && t > 0;
    }(t.delay) ? {
        contentResolved: !1,
        delay: t.delay,
        delayTimer: null
    } : null;
    const h = /*#__PURE__*/ Fu(Nd, [ n, o ], '{display:p0.value==="content"&&p1.value?"contents":"none"}');
    const d = t.fallback$ ? t.fallback$.getFn(sa())() : null;
    const p = i ? /*#__PURE__*/ Ks(rp, {
        boundary: f,
        fallbackStyle: Fu(Md, [ t, n, o, s ], op),
        showFallback: u,
        state: n
    }, null, d, 1, null) : /*#__PURE__*/ Ks("div", {
        style: Fu(Md, [ t, n, o, s ], op)
    }, null, d, 1, null);
    return [ p, 
    /*#__PURE__*/ Ks("div", null, i ? {
        [Dd]: c + "",
        style: h
    } : {
        style: h
    }, 
    /*#__PURE__*/ Ks(i ? ip : fo, i ? {
        [Yr]: e,
        boundary: f,
        boundaryId: c,
        contentStyle: h,
        reveal: l
    } : {
        [Yr]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const Od = /*#__PURE__*/ za(
/*#__PURE__*/ Iu(Cd, "_peC"));

const rp = __EXPERIMENTAL__.pendingBoundary ? /*#__PURE__*/ Bd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.fallbackStyle;
    const i = n.varProps.showFallback === !0;
    const c = n.varProps.state;
    i && (o ? s(() => function n(t, e, s) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.C(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, e.delay);
    }(t, o, c)) : c.value = "fallback");
    s(
    /*#__PURE__*/ Ks("div", {
        style: r
    }, null, n.children, 1, null));
}) : null;

const ip = __EXPERIMENTAL__.pendingBoundary ? /*#__PURE__*/ Bd(async (t, n, e) => {
    const s = n.varProps.boundaryId;
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = __EXPERIMENTAL__.catchBoundary && e.parentComponentFrame ? t.resolveContext(e.parentComponentFrame.componentNode, Tf) : void 0;
    const u = t.segment(o, function f(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            return /* @__PURE__ */ Ks(fo, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = R(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        return /* @__PURE__ */ Ks(fo, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    t.write(`<template ${yr}="${s}"></template>`);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(u.then(n => async function e(t, n, s, o, r, i) {
        if (i) {
            i.contentResolved = !0;
            if (i.delayTimer) {
                clearTimeout(i.delayTimer);
                i.delayTimer = null;
            }
        }
        r?.resolve();
        await t.C(async () => {
            t.addRoot(o);
            await Kd(t, n, s, r);
        });
    }(t, s, n, i, c, r)).catch(t => {
        if (l?.Mt) {
            return l.Mt(t);
        }
        if (l?.error !== void 0) {
            return;
        }
        throw t;
    }));
}) : null;

const jd = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Ld.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return Ks("script", null, o, null, 0, "prefetch-service-worker");
};

const Ld =  "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Fd = () => null;

globalThis.__qwik && ir(30, [ globalThis.__qwik, sr ]);

globalThis.__qwik = sr;

export { Fa as $, md as Catch, bd as Each, co as Fragment, gf as NoSerializeSymbol, Od as Pending, Fd as PrefetchGraph, jd as PrefetchServiceWorker, uo as RenderOnce, Ju as Resource, Id as Reveal, po as SSRComment, ho as SSRRaw, yo as SSRStream, $o as SSRStreamBlock, Ef as SerializerSymbol, kd as Show, ao as SkipRender, fo as Slot, Qi as _CONST_PROPS, ea as _DomContainer, mi as _EFFECT_BACK_REF, Wr as _ELEMENT_SEQ, Ki as _EMPTY_ARRAY, ts as _EMPTY_OBJ, Gi as _IMMUTABLE, Xu as _SharedContainer, Fs as _SubscriptionData, su as _SubscriptionPatch, Pc as _Task, Zi as _UNINITIALIZED, Hi as _VAR_PROPS, se as _addProjection, wd as _caC, $d as _caR, Ra as _captures, v as _chk, ve as _createDeserializeContainer, Ma as _createQRL, xn as _createStore, $i as _delay, we as _deserialize, gu as _dumpState, _d as _eaC, vd as _eaT, yn as _executeSsrChores, Fu as _fnSignal, ls as _getConstProps, $a as _getContextContainer, pa as _getContextEvent, da as _getContextHostElement, Ne as _getDomContainer, Ce as _getQContainerElement, w as _getSubscriber, os as _getVarProps, Yn as _handleSSRError, k as _hasSlotProps, Uc as _hasStoreEffects, ef as _hmr, ks as _injectAsyncSignalValue, Fe as _invoke, Vs as _isJSXNode, Qc as _isStore, Un as _isStringifiable, Tc as _isTask, ya as _jsxBranch, no as _jsxC, ro as _jsxQ, eo as _jsxS, Ks as _jsxSorted, to as _jsxSplit, oi as _mapApp_findIndx, ci as _mapArray_get, li as _mapArray_set, Fc as _markSignalAsExternallyOwned, We as _newInvokeContext, Mu as _noopQrl, Nu as _noopQrlDEV, Cd as _peC, xd as _peT, Wn as _preprocessState, Va as _qrlSync, Ln as _qrlToString, xu as _qrlWithChunk, Cu as _qrlWithChunkDEV, qd as _reC, Td as _reR, Ad as _reT, Lu as _regSymbol, ce as _removeProjection, Zn as _reportSSRSignalError, _ as _res, Pf as _resolveContextWithoutSequentialScope, go as _restProps, t as _retryOnPromise, Qu as _rsc, C as _run, ye as _serialize, ee as _setEvent, oe as _setProjectionTarget, Sd as _shC, Ed as _shT, Mn as _task, le as _updateProjectionProps, ie as _useHmr, m as _val, yf as _verifySerializable, Rl as _vnode_ensureElementInflated, $c as _vnode_getAttrKeys, Hl as _vnode_getElementName, Gl as _vnode_getFirstChild, bl as _vnode_getProp, Nl as _vnode_getVNodeForChildNode, Vl as _vnode_insertBefore, $l as _vnode_isElementVNode, wl as _vnode_isMaterialized, ml as _vnode_isTextVNode, vl as _vnode_isVirtualVNode, dl as _vnode_newVirtual, Bl as _vnode_remove, gl as _vnode_setProp, kn as _vnode_toString, wa as _waitUntilRendered, Qn as _walkJSX, Cs as _wrapProp, js as _wrapSignal, Qa as component$, za as componentQrl, Ps as createAsyncQrl, qs as createComputed$, Rs as createComputedQrl, Sf as createContextId, b as createElement, Is as createSerializer$, Ts as createSerializerQrl, As as createSignal, Ha as event$, Da as eventQrl, zc as forceStoreEffects, Ja as getClientManifest, Ne as getDomContainer, je as getLocale, si as getPlatform, b as h, gs as implicit$FirstArg, Iu as inlinedQrl, ju as inlinedQrlDEV, Qe as isDev, qc as isSignal, so as jsx, oo as jsxDEV, lo as jsxs, bf as noSerialize, qu as qrl, Ou as qrlDEV, Ya as render, ii as setPlatform, Wa as sync$, ua as untrack, Bc as unwrapStore, id as useComputed$, rd as useComputedQrl, Uo as useConstant, Rf as useContext, kf as useContextProvider, Ka as useId, Bu as useLexicalScope, Gu as useOn, Zu as useOnDocument, Ku as useOnWindow, ad as useResource$, Hu as useResourceQrl, ld as useSerializer$, od as useSerializerQrl, Ve as useServerData, zo as useSignal, Ga as useStore, Zh as useStyles$, Gh as useStylesQrl, td as useStylesScoped$, Kh as useStylesScopedQrl, hd as useTask$, kc as useTaskQrl, dd as useVisibleTask$, cd as useVisibleTaskQrl, sr as version, Le as withLocale };
